/* tslint:disable */
/* eslint-disable */
/**
 * Analysis Specification for Meta-analysis
 * api to create a meta-analysis specification
 *
 * The version of the OpenAPI document: 1.2
 * Contact: jamesdkent21@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * a holder/reference to the annotation on neurostore
 */
export interface Annotation {
    /**
     * the id of the annotation on neurostore
     */
    'neurostore_id'?: string;
    /**
     * the snapshot taken of the annotation pending a successful run of the meta-analytic algorithm
     */
    'snapshot'?: object | null;
    'snapshot_studyset'?: StudysetSnapshotSummary;
    'neurostore_url'?: string;
}
export interface AnnotationList {
    'results'?: Array<AnnotationReturn>;
    'metadata'?: object;
}
export interface AnnotationPostBody {
    'snapshot_studyset_id'?: string;
    /**
     * the id of the annotation on neurostore
     */
    'neurostore_id'?: string;
    /**
     * the snapshot taken of the annotation pending a successful run of the meta-analytic algorithm
     */
    'snapshot'?: object | null;
    'snapshot_studyset'?: StudysetSnapshotSummary;
    'neurostore_url'?: string;
}
/**
 * A lightweight reference keyed by the Neurostore annotation ID.
 */
export interface AnnotationReference {
    'annotations'?: Array<AnnotationSnapshotSummary>;
}
export interface AnnotationReferenceReturn {
    'annotations'?: Array<AnnotationSnapshotSummary>;
    /**
     * the identifier for the resource.
     */
    'id'?: string;
    /**
     * when the resource was last modified.
     */
    'updated_at'?: string | null;
    /**
     * When the resource was created.
     */
    'created_at'?: string;
    /**
     * Who owns the resource.
     */
    'user'?: string | null;
    'username'?: string | null;
}
export interface AnnotationReturn {
    /**
     * the id of the annotation on neurostore
     */
    'neurostore_id'?: string;
    /**
     * the snapshot taken of the annotation pending a successful run of the meta-analytic algorithm
     */
    'snapshot'?: object | null;
    'snapshot_studyset'?: StudysetSnapshotSummary;
    'neurostore_url'?: string;
    /**
     * the identifier for the resource.
     */
    'id'?: string;
    /**
     * when the resource was last modified.
     */
    'updated_at'?: string | null;
    /**
     * When the resource was created.
     */
    'created_at'?: string;
    /**
     * Who owns the resource.
     */
    'user'?: string | null;
    'username'?: string | null;
}
export interface AnnotationSnapshotSummary {
    /**
     * Compose snapshot annotation identifier.
     */
    'id'?: string;
    /**
     * Canonical md5 hash of the snapshot payload.
     */
    'md5'?: string | null;
}
export interface AnnotationUpdate {
    /**
     * the id of the annotation on neurostore
     */
    'neurostore_id'?: string;
    /**
     * the snapshot taken of the annotation pending a successful run of the meta-analytic algorithm
     */
    'snapshot'?: object | null;
    'snapshot_studyset'?: StudysetSnapshotSummary;
    'neurostore_url'?: string;
    'snapshot_studyset_id'?: string;
}
/**
 * The function/class applying statistical adjustments to the output of the meta-analysis (optional).
 */
export interface Corrector {
    /**
     * the name of the function/class performing the correction. For example FWECorrector from NiMARE would be valid.
     */
    'type'?: string;
    /**
     * key word arguments passed to the corrector to modidy default functionality, such as number of iterations, or the particular method of correction being applied.
     */
    'args'?: object;
}
/**
 * the specification for the function/class running the meta-analysis
 */
export interface Estimator {
    /**
     * the meta-analytic algorithm applied to the data. Currently this should be directly tied to the function/class running the meta-analysis. For example, ALE, or MKDADensity are valid NiMARE classes to put here.
     */
    'type'?: string;
    /**
     * arbitrary keyword arguments to be passed into the function/class to modify default functionality, this could modify the kernel, resampling methods, or any other behavior defined in the function/class (like MKDADensity).
     */
    'args'?: object;
}
export interface MetaAnalysesGet400Response {
    'detail'?: string;
    'status'?: number;
    'title'?: string;
    'type'?: string;
    /**
     * Correlation id for the failing request. Matches the X-Request-ID response header and the server\'s error log.
     */
    'request_id'?: string;
    /**
     * When the error was produced, ISO 8601.
     */
    'timestamp'?: string;
}
/**
 * The combination of the specification determining what meta-analysis to run (required), the studyset to act as input to the meta-analytic algorithm (required), and the annotation to provide human readable annotations as well as acts as an optional filter on which analyses to select within the studyset (optional, but suggested).
 */
export interface MetaAnalysis {
    'specification'?: MetaAnalysisSpecification;
    'neurostore_studyset'?: MetaAnalysisNeurostoreStudyset;
    'neurostore_annotation'?: MetaAnalysisNeurostoreAnnotation;
    /**
     * Human-readable name of the meta-analysis.
     */
    'name'?: string | null;
    /**
     * Long form description of the meta-analysis.
     */
    'description'?: string | null;
    /**
     * whether the meta-analysis is public or private
     */
    'public'?: boolean;
    'tags'?: MetaAnalysisTags;
    'results'?: MetaAnalysisResults;
    'provenance'?: object | null;
    'project'?: string | null;
    /**
     * a special key used to upload the results of this meta analysis. Can be used as an alternative to using your auth token from login. 
     */
    'run_key'?: string;
    /**
     * Ordered history of (studyset, annotation) snapshot pairs recorded each time a MetaAnalysisResult is created. Each entry contains studyset_id, studyset_md5, annotation_id, annotation_md5, result_id, and created_at. 
     */
    'snapshots'?: Array<object> | null;
    'neurostore_analysis'?: NeurostoreAnalysis;
    'cognitive_contrast_cogatlas'?: string | null;
    'cognitive_contrast_cogatlas_id'?: string | null;
    'cognitive_paradigm_cogatlas'?: string | null;
    'cognitive_paradigm_cogatlas_id'?: string | null;
    'neurostore_url'?: string | null;
}
export interface MetaAnalysisJobList {
    'results'?: Array<MetaAnalysisJobResponse>;
    'metadata'?: MetaAnalysisJobListMetadata;
}
export interface MetaAnalysisJobListMetadata {
    /**
     * Number of jobs in the response.
     */
    'count'?: number;
}
export interface MetaAnalysisJobLog {
    /**
     * Epoch timestamp returned by the compose runner.
     */
    'timestamp'?: number;
    /**
     * Log message emitted by the compose runner.
     */
    'message'?: string;
}
export interface MetaAnalysisJobRequest {
    /**
     * Identifier of the meta-analysis to submit.
     */
    'meta_analysis_id': string;
    /**
     * Skip upload of results to Neurostore/Neurovault.
     */
    'no_upload'?: boolean;
}
export interface MetaAnalysisJobResponse {
    /**
     * Identifier returned by the compose runner service.
     */
    'job_id'?: string;
    /**
     * Identifier of the meta-analysis that was submitted.
     */
    'meta_analysis_id'?: string;
    /**
     * Artifact key prefix for logs and outputs.
     */
    'artifact_prefix'?: string;
    /**
     * Latest known status reported by the compose runner.
     */
    'status'?: string;
    /**
     * Convenience URL for polling job status.
     */
    'status_url'?: string | null;
    /**
     * Deployment environment the job was submitted to.
     */
    'environment'?: string;
    /**
     * Indicates whether the upload step was skipped.
     */
    'no_upload'?: boolean;
    /**
     * Start time reported by the compose runner status endpoint.
     */
    'start_time'?: string | null;
    /**
     * Raw output payload returned by the compose runner.
     */
    'output'?: { [key: string]: any; } | null;
    /**
     * Aggregated log events returned by the compose runner.
     */
    'logs'?: Array<MetaAnalysisJobLog>;
    /**
     * Timestamp when the job entry was cached.
     */
    'created_at'?: string | null;
    /**
     * Timestamp when the job entry was last refreshed.
     */
    'updated_at'?: string | null;
}
export interface MetaAnalysisList {
    'results'?: Array<MetaAnalysisReturn>;
    'metadata'?: object;
}
/**
 * @type MetaAnalysisNeurostoreAnnotation
 */
export type MetaAnalysisNeurostoreAnnotation = Annotation | string;

/**
 * @type MetaAnalysisNeurostoreStudyset
 */
export type MetaAnalysisNeurostoreStudyset = Studyset | string;

export interface MetaAnalysisPostBody {
    'specification'?: MetaAnalysisSpecification;
    'neurostore_studyset'?: MetaAnalysisNeurostoreStudyset;
    'neurostore_annotation'?: MetaAnalysisNeurostoreAnnotation;
    /**
     * Human-readable name of the meta-analysis.
     */
    'name'?: string | null;
    /**
     * Long form description of the meta-analysis.
     */
    'description'?: string | null;
    /**
     * whether the meta-analysis is public or private
     */
    'public'?: boolean;
    'tags'?: MetaAnalysisTags;
    'results'?: MetaAnalysisResults;
    'provenance'?: object | null;
    'project'?: string | null;
    /**
     * a special key used to upload the results of this meta analysis. Can be used as an alternative to using your auth token from login. 
     */
    'run_key'?: string;
    /**
     * Ordered history of (studyset, annotation) snapshot pairs recorded each time a MetaAnalysisResult is created. Each entry contains studyset_id, studyset_md5, annotation_id, annotation_md5, result_id, and created_at. 
     */
    'snapshots'?: Array<object> | null;
    'neurostore_analysis'?: NeurostoreAnalysis;
    'cognitive_contrast_cogatlas'?: string | null;
    'cognitive_contrast_cogatlas_id'?: string | null;
    'cognitive_paradigm_cogatlas'?: string | null;
    'cognitive_paradigm_cogatlas_id'?: string | null;
    'neurostore_url'?: string | null;
}
/**
 * @type MetaAnalysisResults
 * array of neurostore ids representing the results of this meta-analysis (nominally all results should be the same, but machine architecture differences/algorithm stochastic-ness may lead to slightly different outcomes for each result.
 */
export type MetaAnalysisResults = Array<ResultReturn> | Array<string>;

export interface MetaAnalysisReturn {
    'specification'?: MetaAnalysisSpecification;
    'neurostore_studyset'?: MetaAnalysisNeurostoreStudyset;
    'neurostore_annotation'?: MetaAnalysisNeurostoreAnnotation;
    /**
     * Human-readable name of the meta-analysis.
     */
    'name'?: string | null;
    /**
     * Long form description of the meta-analysis.
     */
    'description'?: string | null;
    /**
     * whether the meta-analysis is public or private
     */
    'public'?: boolean;
    'tags'?: MetaAnalysisTags;
    'results'?: MetaAnalysisResults;
    'provenance'?: object | null;
    'project'?: string | null;
    /**
     * a special key used to upload the results of this meta analysis. Can be used as an alternative to using your auth token from login. 
     */
    'run_key'?: string;
    /**
     * Ordered history of (studyset, annotation) snapshot pairs recorded each time a MetaAnalysisResult is created. Each entry contains studyset_id, studyset_md5, annotation_id, annotation_md5, result_id, and created_at. 
     */
    'snapshots'?: Array<object> | null;
    'neurostore_analysis'?: NeurostoreAnalysis;
    'cognitive_contrast_cogatlas'?: string | null;
    'cognitive_contrast_cogatlas_id'?: string | null;
    'cognitive_paradigm_cogatlas'?: string | null;
    'cognitive_paradigm_cogatlas_id'?: string | null;
    'neurostore_url'?: string | null;
    /**
     * the identifier for the resource.
     */
    'id'?: string;
    /**
     * when the resource was last modified.
     */
    'updated_at'?: string | null;
    /**
     * When the resource was created.
     */
    'created_at'?: string;
    /**
     * Who owns the resource.
     */
    'user'?: string | null;
    'username'?: string | null;
}
/**
 * @type MetaAnalysisSpecification
 */
export type MetaAnalysisSpecification = Specification | string;

/**
 * @type MetaAnalysisTags
 * Tags associated with this meta-analysis (use tag names or tag IDs).
 */
export type MetaAnalysisTags = Array<Tag> | Array<string>;

export interface NeurostoreAnalysis {
    'neurostore_id'?: string | null;
    'exception'?: string | null;
    'traceback'?: string | null;
    'status'?: string | null;
}
export interface NeurostoreStudy {
    'neurostore_id'?: string | null;
    'analyses'?: Array<NeurostoreAnalysis>;
    'exception'?: string | null;
    'traceback'?: string | null;
    'status'?: string | null;
}
export interface NeurostoreStudyList {
    'results'?: Array<NeurostoreStudyReturn>;
    'metadata'?: object;
}
export interface NeurostoreStudyReturn {
    'neurostore_id'?: string | null;
    'analyses'?: Array<NeurostoreAnalysis>;
    'exception'?: string | null;
    'traceback'?: string | null;
    'status'?: string | null;
    /**
     * the identifier for the resource.
     */
    'id'?: string;
    /**
     * when the resource was last modified.
     */
    'updated_at'?: string | null;
    /**
     * When the resource was created.
     */
    'created_at'?: string;
    /**
     * Who owns the resource.
     */
    'user'?: string | null;
    'username'?: string | null;
}
export interface NeurovaultCollection {
    'collection_id'?: string | null;
    'files'?: Array<NeurovaultCollectionFilesInner>;
    'url'?: string | null;
}
/**
 * @type NeurovaultCollectionFilesInner
 */
export type NeurovaultCollectionFilesInner = NeurovaultFile | string;

export interface NeurovaultCollectionReturn {
    'collection_id'?: string | null;
    'files'?: Array<NeurovaultCollectionFilesInner>;
    'url'?: string | null;
    /**
     * the identifier for the resource.
     */
    'id'?: string;
    /**
     * when the resource was last modified.
     */
    'updated_at'?: string | null;
    /**
     * When the resource was created.
     */
    'created_at'?: string;
    /**
     * Who owns the resource.
     */
    'user'?: string | null;
    'username'?: string | null;
}
export interface NeurovaultFile {
    'collection_id'?: string | null;
    'exception'?: string | null;
    'traceback'?: string | null;
    'status'?: string;
    'image_id'?: string | null;
    'name'?: string | null;
    'url'?: string | null;
    'file'?: File;
}
export interface NeurovaultFileList {
    'results'?: Array<NeurovaultFileReturn>;
    'metadata'?: object;
}
export interface NeurovaultFileReturn {
    'collection_id'?: string | null;
    'exception'?: string | null;
    'traceback'?: string | null;
    'status'?: string;
    'image_id'?: string | null;
    'name'?: string | null;
    'url'?: string | null;
    'file'?: File;
    /**
     * the identifier for the resource.
     */
    'id'?: string;
    /**
     * when the resource was last modified.
     */
    'updated_at'?: string | null;
    /**
     * When the resource was created.
     */
    'created_at'?: string;
    /**
     * Who owns the resource.
     */
    'user'?: string | null;
    'username'?: string | null;
}
export interface NeurovaultList {
    'results'?: Array<NeurovaultCollectionReturn>;
    'metadata'?: object;
}
export interface Project {
    'provenance'?: object | null;
    'meta_analyses'?: ProjectMetaAnalyses;
    'name'?: string | null;
    'description'?: string | null;
    'type'?: ProjectTypeEnum;
    /**
     * ID of the project’s linked Neurostore studyset reference.
     */
    'neurostore_studyset_id'?: string | null;
    /**
     * ID of the project’s linked Neurostore annotation reference.
     */
    'neurostore_annotation_id'?: string | null;
    'tags'?: ProjectTags;
    /**
     * whether the project is public or private
     */
    'public'?: boolean;
    'neurostore_study'?: NeurostoreStudy;
    'neurostore_url'?: string | null;
    'draft'?: boolean;
}

export const ProjectTypeEnum = {
    Cbma: 'CBMA',
    Ibma: 'IBMA'
} as const;

export type ProjectTypeEnum = typeof ProjectTypeEnum[keyof typeof ProjectTypeEnum];

export interface ProjectList {
    'results'?: Array<ProjectReturn>;
    'metadata'?: object;
}
/**
 * @type ProjectMetaAnalyses
 */
export type ProjectMetaAnalyses = Array<MetaAnalysis> | Array<string>;

export interface ProjectReturn {
    /**
     * the identifier for the resource.
     */
    'id'?: string;
    /**
     * when the resource was last modified.
     */
    'updated_at'?: string | null;
    /**
     * When the resource was created.
     */
    'created_at'?: string;
    /**
     * Who owns the resource.
     */
    'user'?: string | null;
    'username'?: string | null;
    'provenance'?: object | null;
    'meta_analyses'?: ProjectMetaAnalyses;
    'name'?: string | null;
    'description'?: string | null;
    'type'?: ProjectReturnTypeEnum;
    /**
     * ID of the project’s linked Neurostore studyset reference.
     */
    'neurostore_studyset_id'?: string | null;
    /**
     * ID of the project’s linked Neurostore annotation reference.
     */
    'neurostore_annotation_id'?: string | null;
    'tags'?: ProjectTags;
    /**
     * whether the project is public or private
     */
    'public'?: boolean;
    'neurostore_study'?: NeurostoreStudy;
    'neurostore_url'?: string | null;
    'draft'?: boolean;
}

export const ProjectReturnTypeEnum = {
    Cbma: 'CBMA',
    Ibma: 'IBMA'
} as const;

export type ProjectReturnTypeEnum = typeof ProjectReturnTypeEnum[keyof typeof ProjectReturnTypeEnum];

/**
 * @type ProjectTags
 * Tags associated with this project (use tag names or tag IDs). A name that does not match an existing tag creates a private tag owned by the caller.
 */
export type ProjectTags = Array<Tag> | Array<string>;

export interface ReadOnly {
    /**
     * the identifier for the resource.
     */
    'id'?: string;
    /**
     * when the resource was last modified.
     */
    'updated_at'?: string | null;
    /**
     * When the resource was created.
     */
    'created_at'?: string;
    /**
     * Who owns the resource.
     */
    'user'?: string | null;
    'username'?: string | null;
}
/**
 * describes the output of a meta-analysis
 */
export interface Result {
    /**
     * the meta analysis this result was derived from.
     */
    'meta_analysis_id'?: string;
    /**
     * version of the command-line-tool that is uploading the results. 
     */
    'cli_version'?: string | null;
    'neurovault_collection'?: NeurovaultCollectionReturn;
    /**
     * the description of the methods applied to create this result.
     */
    'method_description'?: string | null;
    /**
     * BibTeX-formatted references cited by method_description. 
     */
    'method_references'?: string | null;
    /**
     * a text representation of a tsv that marks the contribution of each study to each particular cluster.
     */
    'diagnostic_table'?: string | null;
    /**
     * additional parameters that were passed to the commandline tool at runtime. 
     */
    'cli_args'?: object | null;
    'status'?: string | null;
}
export interface ResultInit {
    'meta_analysis_id'?: string;
    'snapshot_studyset'?: object;
    'snapshot_annotation'?: object;
    /**
     * ID of an existing cached studyset snapshot to link to this result.
     */
    'snapshot_studyset_id'?: string;
    /**
     * ID of an existing cached annotation snapshot to link to this result.
     */
    'snapshot_annotation_id'?: string;
    'cli_version'?: string;
}
export interface ResultList {
    'results'?: ResultListResults;
    'metadata'?: object;
}
/**
 * @type ResultListResults
 */
export type ResultListResults = Array<ResultReturn> | Array<string>;

export interface ResultReturn {
    /**
     * the meta analysis this result was derived from.
     */
    'meta_analysis_id'?: string;
    /**
     * version of the command-line-tool that is uploading the results. 
     */
    'cli_version'?: string | null;
    'neurovault_collection'?: NeurovaultCollectionReturn;
    /**
     * the description of the methods applied to create this result.
     */
    'method_description'?: string | null;
    /**
     * BibTeX-formatted references cited by method_description. 
     */
    'method_references'?: string | null;
    /**
     * a text representation of a tsv that marks the contribution of each study to each particular cluster.
     */
    'diagnostic_table'?: string | null;
    /**
     * additional parameters that were passed to the commandline tool at runtime. 
     */
    'cli_args'?: object | null;
    'status'?: string | null;
    /**
     * the identifier for the resource.
     */
    'id'?: string;
    /**
     * when the resource was last modified.
     */
    'updated_at'?: string | null;
    /**
     * When the resource was created.
     */
    'created_at'?: string;
    /**
     * Who owns the resource.
     */
    'user'?: string | null;
    'username'?: string | null;
    'snapshot_studyset_id'?: string | null;
    'snapshot_annotation_id'?: string | null;
}
/**
 * @type ResultUploadStatisticalMaps
 */
export type ResultUploadStatisticalMaps = Array<File> | File;

/**
 * a machine readable specification of how to run a meta-analysis (currently specifically tailored to NiMARE).
 */
export interface Specification {
    /**
     * the type of meta-analysis being run, typically either cbma or ibma, but others may become available in the future.
     */
    'type'?: string;
    'estimator'?: Estimator;
    /**
     * a string representing a binary nifti file to select which voxels a user wants to include in the analysis.
     */
    'mask'?: string | null;
    'conditions'?: SpecificationConditions;
    'weights'?: Array<number> | null;
    /**
     * A transformation applied to column(s) (e.g., binarize based on a threshold). This is likely to become deprecated.
     */
    'transformer'?: string | null;
    'corrector'?: Corrector | null;
    /**
     * a column from annotations selecting which analyses to include in the meta-analysis
     */
    'filter'?: string | null;
    'database_studyset'?: string | null;
}
/**
 * @type SpecificationConditions
 * selection of categories in the filter column to differentiate groups, or \"neurosynth\", \"neuroquery\", or \"neurostore\" to compare to a database reference group
 */
export type SpecificationConditions = Array<boolean> | Array<string>;

/**
 * The representation of a list of specifications.
 */
export interface SpecificationList {
    'results'?: Array<SpecificationReturn>;
    'metadata'?: object;
}
export interface SpecificationPostBody {
    /**
     * the type of meta-analysis being run, typically either cbma or ibma, but others may become available in the future.
     */
    'type'?: string;
    'estimator'?: Estimator;
    /**
     * a string representing a binary nifti file to select which voxels a user wants to include in the analysis.
     */
    'mask'?: string | null;
    'conditions'?: SpecificationConditions;
    'weights'?: Array<number> | null;
    /**
     * A transformation applied to column(s) (e.g., binarize based on a threshold). This is likely to become deprecated.
     */
    'transformer'?: string | null;
    'corrector'?: Corrector | null;
    /**
     * a column from annotations selecting which analyses to include in the meta-analysis
     */
    'filter'?: string | null;
    'database_studyset'?: string | null;
}
/**
 * The view of the specification through an endpoint.
 */
export interface SpecificationReturn {
    /**
     * the type of meta-analysis being run, typically either cbma or ibma, but others may become available in the future.
     */
    'type'?: string;
    'estimator'?: Estimator;
    /**
     * a string representing a binary nifti file to select which voxels a user wants to include in the analysis.
     */
    'mask'?: string | null;
    'conditions'?: SpecificationConditions;
    'weights'?: Array<number> | null;
    /**
     * A transformation applied to column(s) (e.g., binarize based on a threshold). This is likely to become deprecated.
     */
    'transformer'?: string | null;
    'corrector'?: Corrector | null;
    /**
     * a column from annotations selecting which analyses to include in the meta-analysis
     */
    'filter'?: string | null;
    'database_studyset'?: string | null;
    /**
     * the identifier for the resource.
     */
    'id'?: string;
    /**
     * when the resource was last modified.
     */
    'updated_at'?: string | null;
    /**
     * When the resource was created.
     */
    'created_at'?: string;
    /**
     * Who owns the resource.
     */
    'user'?: string | null;
    'username'?: string | null;
}
export interface Studyset {
    /**
     * The id of the studyset on neurostore.
     */
    'neurostore_id'?: string;
    /**
     * The snapshot of the studyset pending a successful run of the meta-analysis.
     */
    'snapshot'?: object | null;
    /**
     * Compact summaries of cached annotations paired with this studyset snapshot.
     */
    'annotations'?: Array<AnnotationSnapshotSummary>;
    'neurostore_url'?: string;
    /**
     * A string representing a labeled version of this particular studyset.
     */
    'version'?: string | null;
}
export interface StudysetList {
    'results'?: Array<StudysetReturn>;
    'metadata'?: object;
}
export interface StudysetPostBody {
    /**
     * The id of the studyset on neurostore.
     */
    'neurostore_id'?: string;
    /**
     * The snapshot of the studyset pending a successful run of the meta-analysis.
     */
    'snapshot'?: object | null;
    /**
     * Compact summaries of cached annotations paired with this studyset snapshot.
     */
    'annotations'?: Array<AnnotationSnapshotSummary>;
    'neurostore_url'?: string;
    /**
     * A string representing a labeled version of this particular studyset.
     */
    'version'?: string | null;
}
export interface StudysetReference {
    'studysets'?: Array<StudysetSnapshotSummary>;
}
export interface StudysetReferenceList {
    'results'?: Array<StudysetReferenceReturn>;
    'metadata'?: object;
}
export interface StudysetReferenceReturn {
    'studysets'?: Array<StudysetSnapshotSummary>;
    /**
     * the identifier for the resource.
     */
    'id'?: string;
    /**
     * when the resource was last modified.
     */
    'updated_at'?: string | null;
    /**
     * When the resource was created.
     */
    'created_at'?: string;
    /**
     * Who owns the resource.
     */
    'user'?: string | null;
    'username'?: string | null;
}
export interface StudysetReturn {
    /**
     * The id of the studyset on neurostore.
     */
    'neurostore_id'?: string;
    /**
     * The snapshot of the studyset pending a successful run of the meta-analysis.
     */
    'snapshot'?: object | null;
    /**
     * Compact summaries of cached annotations paired with this studyset snapshot.
     */
    'annotations'?: Array<AnnotationSnapshotSummary>;
    'neurostore_url'?: string;
    /**
     * A string representing a labeled version of this particular studyset.
     */
    'version'?: string | null;
    /**
     * the identifier for the resource.
     */
    'id'?: string;
    /**
     * when the resource was last modified.
     */
    'updated_at'?: string | null;
    /**
     * When the resource was created.
     */
    'created_at'?: string;
    /**
     * Who owns the resource.
     */
    'user'?: string | null;
    'username'?: string | null;
}
export interface StudysetSnapshotSummary {
    /**
     * Compose snapshot studyset identifier.
     */
    'id'?: string;
    /**
     * Canonical md5 hash of the snapshot payload.
     */
    'md5'?: string | null;
}
/**
 * A user-scoped or global label that can be attached to multiple resources. Tag groups are free-form categories (e.g., \"visibility\", \"topic\") used to segment tags across different resource types.
 */
export interface Tag {
    /**
     * Case-insensitive unique name within the tag scope (user or global).
     */
    'name': string;
    /**
     * Optional grouping key to categorize tags (case-insensitive exact match in queries).
     */
    'group'?: string | null;
    'description'?: string | null;
    'official'?: boolean | null;
}
export interface TagList {
    'results'?: Array<TagReturn>;
    'metadata'?: object;
}
export interface TagReturn {
    /**
     * Case-insensitive unique name within the tag scope (user or global).
     */
    'name': string;
    /**
     * Optional grouping key to categorize tags (case-insensitive exact match in queries).
     */
    'group'?: string | null;
    'description'?: string | null;
    'official'?: boolean | null;
    /**
     * the identifier for the resource.
     */
    'id'?: string;
    /**
     * when the resource was last modified.
     */
    'updated_at'?: string | null;
    /**
     * When the resource was created.
     */
    'created_at'?: string;
    /**
     * Who owns the resource.
     */
    'user'?: string | null;
    'username'?: string | null;
}
/**
 * attributes of the user object
 */
export interface User {
    'external_id'?: string;
}
export interface UserList {
    'results'?: Array<UserReturn>;
    'metadata'?: object;
}
export interface UserReturn {
    'external_id'?: string;
    /**
     * the identifier for the resource.
     */
    'id'?: string;
    /**
     * when the resource was last modified.
     */
    'updated_at'?: string | null;
    /**
     * When the resource was created.
     */
    'created_at'?: string;
    /**
     * Who owns the resource.
     */
    'user'?: string | null;
    'username'?: string | null;
}

/**
 * ComposeApi - axios parameter creator
 */
export const ComposeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * list all runnable specification, studyset, annotation bundles
         * @summary GET a list of meta-analyses
         * @param {boolean} [nested] show nested component instead of id
         * @param {Array<string>} [ids] choose the specific ids you wish to get
         * @param {number} [page] page of results
         * @param {number} [pageSize] number of elements to return on a page
         * @param {string} [name] search the name field for a term
         * @param {string} [search] search for entries that contain the substring
         * @param {string} [description] search description field for a term
         * @param {string} [sort] Parameter to sort results on
         * @param {boolean} [desc] sort results by descending order (as opposed to ascending order)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metaAnalysesGet: async (nested?: boolean, ids?: Array<string>, page?: number, pageSize?: number, name?: string, search?: string, description?: string, sort?: string, desc?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/meta-analyses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JSON-Web-Token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nested !== undefined) {
                localVarQueryParameter['nested'] = nested;
            }

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (description !== undefined) {
                localVarQueryParameter['description'] = description;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (desc !== undefined) {
                localVarQueryParameter['desc'] = desc;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get a meta-analysis (specification, annotation, and studyset)
         * @summary GET meta-analysis information
         * @param {string} id 
         * @param {boolean} [nested] show nested component instead of id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metaAnalysesIdGet: async (id: string, nested?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('metaAnalysesIdGet', 'id', id)
            const localVarPath = `/meta-analyses/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (nested !== undefined) {
                localVarQueryParameter['nested'] = nested;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update an existing meta-analysis (that has not yet been run)
         * @summary Update a meta-analysis
         * @param {string} id 
         * @param {MetaAnalysis} [metaAnalysis] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metaAnalysesIdPut: async (id: string, metaAnalysis?: MetaAnalysis, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('metaAnalysesIdPut', 'id', id)
            const localVarPath = `/meta-analyses/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JSON-Web-Token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(metaAnalysis, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * create a new specification, studyset, annotation bundle
         * @summary Create a new meta-analysis
         * @param {MetaAnalysisPostBody} [metaAnalysisPostBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metaAnalysesPost: async (metaAnalysisPostBody?: MetaAnalysisPostBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/meta-analyses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JSON-Web-Token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(metaAnalysisPostBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return cached job submissions associated with the authenticated user.
         * @summary List meta-analysis jobs for the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metaAnalysisJobsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/meta-analysis-jobs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JSON-Web-Token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve the most recent status information and logs for a submitted job.
         * @summary Get status and logs for a meta-analysis job
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metaAnalysisJobsJobIdGet: async (jobId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('metaAnalysisJobsJobIdGet', 'jobId', jobId)
            const localVarPath = `/meta-analysis-jobs/{job_id}`
                .replace(`{${"job_id"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JSON-Web-Token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Submit a meta-analysis to the compose runner service.
         * @summary Submit a meta-analysis job
         * @param {MetaAnalysisJobRequest} metaAnalysisJobRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metaAnalysisJobsPost: async (metaAnalysisJobRequest: MetaAnalysisJobRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'metaAnalysisJobRequest' is not null or undefined
            assertParamExists('metaAnalysisJobsPost', 'metaAnalysisJobRequest', metaAnalysisJobRequest)
            const localVarPath = `/meta-analysis-jobs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JSON-Web-Token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(metaAnalysisJobRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List meta-analysis results
         * @param {string} [metaAnalysisId] search for results with this meta-analysis id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metaAnalysisResultsGet: async (metaAnalysisId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/meta-analysis-results`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (metaAnalysisId !== undefined) {
                localVarQueryParameter['meta_analysis_id'] = metaAnalysisId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a meta-analysis result by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metaAnalysisResultsIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('metaAnalysisResultsIdGet', 'id', id)
            const localVarPath = `/meta-analysis-results/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a meta-analysis result with files or snapshots
         * @param {string} id 
         * @param {ResultUploadStatisticalMaps} [statisticalMaps] 
         * @param {ResultUploadStatisticalMaps} [clusterTables] 
         * @param {ResultUploadStatisticalMaps} [diagnosticTables] 
         * @param {string} [methodDescription] the description of the methods applied to create this result.
         * @param {string} [methodReferences] BibTeX-formatted references cited by method_description. 
         * @param {string} [snapshotStudyset] JSON-encoded studyset snapshot payload, optionally provided in multipart form.
         * @param {string} [snapshotAnnotation] JSON-encoded annotation snapshot payload, optionally provided in multipart form.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metaAnalysisResultsIdPut: async (id: string, statisticalMaps?: ResultUploadStatisticalMaps, clusterTables?: ResultUploadStatisticalMaps, diagnosticTables?: ResultUploadStatisticalMaps, methodDescription?: string, methodReferences?: string, snapshotStudyset?: string, snapshotAnnotation?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('metaAnalysisResultsIdPut', 'id', id)
            const localVarPath = `/meta-analysis-results/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication JSON-Web-Token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication upload_key required
            await setApiKeyToObject(localVarHeaderParameter, "Compose-Upload-Key", configuration)


            if (statisticalMaps !== undefined) { 
                localVarFormParams.append('statistical_maps', new Blob([JSON.stringify(statisticalMaps)], { type: "application/json", }));
            }
    
            if (clusterTables !== undefined) { 
                localVarFormParams.append('cluster_tables', new Blob([JSON.stringify(clusterTables)], { type: "application/json", }));
            }
    
            if (diagnosticTables !== undefined) { 
                localVarFormParams.append('diagnostic_tables', new Blob([JSON.stringify(diagnosticTables)], { type: "application/json", }));
            }
    
            if (methodDescription !== undefined) { 
                localVarFormParams.append('method_description', methodDescription as any);
            }
    
            if (methodReferences !== undefined) { 
                localVarFormParams.append('method_references', methodReferences as any);
            }
    
            if (snapshotStudyset !== undefined) { 
                localVarFormParams.append('snapshot_studyset', snapshotStudyset as any);
            }
    
            if (snapshotAnnotation !== undefined) { 
                localVarFormParams.append('snapshot_annotation', snapshotAnnotation as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new meta-analysis result
         * @param {ResultInit} [resultInit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metaAnalysisResultsPost: async (resultInit?: ResultInit, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/meta-analysis-results`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JSON-Web-Token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication upload_key required
            await setApiKeyToObject(localVarHeaderParameter, "Compose-Upload-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resultInit, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Resolve a Neurostore annotation reference using the same ID exposed by the Neurostore API, including each linked snapshot\'s compose ID and md5.
         * @summary Get a Neurostore annotation reference by Neurostore ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        neurostoreAnnotationsIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('neurostoreAnnotationsIdGet', 'id', id)
            const localVarPath = `/neurostore-annotations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Your GET endpoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        neurostoreStudiesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/neurostore-studies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Your GET endpoint
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        neurostoreStudiesIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('neurostoreStudiesIdGet', 'id', id)
            const localVarPath = `/neurostore-studies/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List reference rows keyed by the actual Neurostore studyset ID, including compact snapshot summaries.
         * @summary List Neurostore studyset references
         * @param {boolean} [nested] show nested component instead of id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        neurostoreStudysetsGet: async (nested?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/neurostore-studysets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (nested !== undefined) {
                localVarQueryParameter['nested'] = nested;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Resolve a Neurostore studyset reference using the same ID exposed by the Neurostore API, including each linked snapshot\'s compose ID and md5.
         * @summary Get a Neurostore studyset reference by Neurostore ID
         * @param {string} id 
         * @param {boolean} [nested] show nested component instead of id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        neurostoreStudysetsIdGet: async (id: string, nested?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('neurostoreStudysetsIdGet', 'id', id)
            const localVarPath = `/neurostore-studysets/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (nested !== undefined) {
                localVarQueryParameter['nested'] = nested;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get neurovault collections
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        neurovaultCollectionsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/neurovault-collections`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Your GET endpoint
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        neurovaultCollectionsIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('neurovaultCollectionsIdGet', 'id', id)
            const localVarPath = `/neurovault-collections/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        neurovaultCollectionsIdPut: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('neurovaultCollectionsIdPut', 'id', id)
            const localVarPath = `/neurovault-collections/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JSON-Web-Token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create neurovault collection
         * @param {NeurovaultCollection} [neurovaultCollection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        neurovaultCollectionsPost: async (neurovaultCollection?: NeurovaultCollection, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/neurovault-collections`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JSON-Web-Token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(neurovaultCollection, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Your GET endpoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        neurovaultFilesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/neurovault-files`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Your GET endpoint
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        neurovaultFilesIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('neurovaultFilesIdGet', 'id', id)
            const localVarPath = `/neurovault-files/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {string | null} [collectionId] 
         * @param {string | null} [exception] 
         * @param {string | null} [traceback] 
         * @param {string} [status] 
         * @param {string | null} [imageId] 
         * @param {string | null} [name] 
         * @param {string | null} [url] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        neurovaultFilesIdPut: async (id: string, collectionId?: string | null, exception?: string | null, traceback?: string | null, status?: string, imageId?: string | null, name?: string | null, url?: string | null, file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('neurovaultFilesIdPut', 'id', id)
            const localVarPath = `/neurovault-files/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication JSON-Web-Token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (collectionId !== undefined) { 
                localVarFormParams.append('collection_id', collectionId as any);
            }
    
            if (exception !== undefined) { 
                localVarFormParams.append('exception', exception as any);
            }
    
            if (traceback !== undefined) { 
                localVarFormParams.append('traceback', traceback as any);
            }
    
            if (status !== undefined) { 
                localVarFormParams.append('status', status as any);
            }
    
            if (imageId !== undefined) { 
                localVarFormParams.append('image_id', imageId as any);
            }
    
            if (name !== undefined) { 
                localVarFormParams.append('name', name as any);
            }
    
            if (url !== undefined) { 
                localVarFormParams.append('url', url as any);
            }
    
            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {NeurovaultFile} [neurovaultFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        neurovaultFilesPost: async (neurovaultFile?: NeurovaultFile, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/neurovault-files`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JSON-Web-Token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(neurovaultFile, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Your GET endpoint
         * @param {number} [page] page of results
         * @param {number} [pageSize] number of elements to return on a page
         * @param {string} [name] search the name field for a term
         * @param {string} [search] search for entries that contain the substring
         * @param {string} [description] search description field for a term
         * @param {string} [sort] Parameter to sort results on
         * @param {boolean} [desc] sort results by descending order (as opposed to ascending order)
         * @param {string} [userId] user id you want to filter on
         * @param {boolean} [includeProvenance] include the project provenance payload in project responses
         * @param {Array<string>} [tag] only return projects carrying every one of these tag names (case-insensitive)
         * @param {Array<string>} [excludeTag] drop projects carrying any of these tag names (case-insensitive); use this to hide projects a user has tagged away
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectsGet: async (page?: number, pageSize?: number, name?: string, search?: string, description?: string, sort?: string, desc?: boolean, userId?: string, includeProvenance?: boolean, tag?: Array<string>, excludeTag?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/projects`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JSON-Web-Token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (description !== undefined) {
                localVarQueryParameter['description'] = description;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (desc !== undefined) {
                localVarQueryParameter['desc'] = desc;
            }

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }

            if (includeProvenance !== undefined) {
                localVarQueryParameter['include_provenance'] = includeProvenance;
            }

            if (tag) {
                localVarQueryParameter['tag'] = tag.join(COLLECTION_FORMATS.csv);
            }

            if (excludeTag) {
                localVarQueryParameter['exclude_tag'] = excludeTag.join(COLLECTION_FORMATS.csv);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectsIdDelete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('projectsIdDelete', 'id', id)
            const localVarPath = `/projects/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JSON-Web-Token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Your GET endpoint
         * @param {string} id 
         * @param {boolean} [info] display additional information about a nested relationship without displaying fully nested object
         * @param {boolean} [includeProvenance] include the project provenance payload in project responses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectsIdGet: async (id: string, info?: boolean, includeProvenance?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('projectsIdGet', 'id', id)
            const localVarPath = `/projects/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (info !== undefined) {
                localVarQueryParameter['info'] = info;
            }

            if (includeProvenance !== undefined) {
                localVarQueryParameter['include_provenance'] = includeProvenance;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {boolean} [syncMetaAnalysesPublic] when updating a project\&#39;s public flag, also set each child meta-analysis to the same public value
         * @param {Project} [project] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectsIdPut: async (id: string, syncMetaAnalysesPublic?: boolean, project?: Project, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('projectsIdPut', 'id', id)
            const localVarPath = `/projects/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JSON-Web-Token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (syncMetaAnalysesPublic !== undefined) {
                localVarQueryParameter['sync_meta_analyses_public'] = syncMetaAnalysesPublic;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(project, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} [sourceId] clone an existing project when creating a new project
         * @param {boolean} [copyAnnotations] when cloning via &#x60;source_id&#x60;, also duplicate associated annotations
         * @param {Project} [project] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectsPost: async (sourceId?: string, copyAnnotations?: boolean, project?: Project, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/projects`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JSON-Web-Token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (sourceId !== undefined) {
                localVarQueryParameter['source_id'] = sourceId;
            }

            if (copyAnnotations !== undefined) {
                localVarQueryParameter['copy_annotations'] = copyAnnotations;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(project, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get a list of serialized/referenced annotations
         * @summary GET a list of annotations
         * @param {boolean} [nested] show nested component instead of id
         * @param {Array<string>} [ids] choose the specific ids you wish to get
         * @param {number} [page] page of results
         * @param {number} [pageSize] number of elements to return on a page
         * @param {string} [search] search for entries that contain the substring
         * @param {string} [sort] Parameter to sort results on
         * @param {boolean} [desc] sort results by descending order (as opposed to ascending order)
         * @param {string} [userId] user id you want to filter on
         * @param {boolean} [info] display additional information about a nested relationship without displaying fully nested object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snapshotAnnotationsGet: async (nested?: boolean, ids?: Array<string>, page?: number, pageSize?: number, search?: string, sort?: string, desc?: boolean, userId?: string, info?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/snapshot-annotations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (nested !== undefined) {
                localVarQueryParameter['nested'] = nested;
            }

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (desc !== undefined) {
                localVarQueryParameter['desc'] = desc;
            }

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }

            if (info !== undefined) {
                localVarQueryParameter['info'] = info;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get a single annotation
         * @summary GET information about an annotation
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snapshotAnnotationsIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('snapshotAnnotationsIdGet', 'id', id)
            const localVarPath = `/snapshot-annotations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update an existing annotation
         * @summary Update an Annotation
         * @param {string} id 
         * @param {AnnotationUpdate} [annotationUpdate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snapshotAnnotationsIdPut: async (id: string, annotationUpdate?: AnnotationUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('snapshotAnnotationsIdPut', 'id', id)
            const localVarPath = `/snapshot-annotations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JSON-Web-Token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(annotationUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * create a new serialized/referenced annotation
         * @summary Create a new Annotation
         * @param {AnnotationPostBody} [annotationPostBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snapshotAnnotationsPost: async (annotationPostBody?: AnnotationPostBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/snapshot-annotations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JSON-Web-Token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(annotationPostBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get a list of serialized/referenced studysets
         * @summary Get a list of Studysets
         * @param {boolean} [nested] show nested component instead of id
         * @param {Array<string>} [ids] choose the specific ids you wish to get
         * @param {number} [page] page of results
         * @param {number} [pageSize] number of elements to return on a page
         * @param {string} [search] search for entries that contain the substring
         * @param {string} [sort] Parameter to sort results on
         * @param {boolean} [desc] sort results by descending order (as opposed to ascending order)
         * @param {string} [userId] user id you want to filter on
         * @param {boolean} [info] display additional information about a nested relationship without displaying fully nested object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snapshotStudysetsGet: async (nested?: boolean, ids?: Array<string>, page?: number, pageSize?: number, search?: string, sort?: string, desc?: boolean, userId?: string, info?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/snapshot-studysets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (nested !== undefined) {
                localVarQueryParameter['nested'] = nested;
            }

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (desc !== undefined) {
                localVarQueryParameter['desc'] = desc;
            }

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }

            if (info !== undefined) {
                localVarQueryParameter['info'] = info;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get a single serialized/referenced studyset
         * @summary Get information about a Studyset
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snapshotStudysetsIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('snapshotStudysetsIdGet', 'id', id)
            const localVarPath = `/snapshot-studysets/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update an existing serialized/referenced studyset
         * @summary Update a Studyset
         * @param {string} id 
         * @param {Studyset} [studyset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snapshotStudysetsIdPut: async (id: string, studyset?: Studyset, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('snapshotStudysetsIdPut', 'id', id)
            const localVarPath = `/snapshot-studysets/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JSON-Web-Token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(studyset, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * create a new serialized/referenced studyset
         * @summary Create a new Studyset
         * @param {StudysetPostBody} [studysetPostBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snapshotStudysetsPost: async (studysetPostBody?: StudysetPostBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/snapshot-studysets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JSON-Web-Token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(studysetPostBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * list of meta-analysis specifications
         * @summary Get a list of Specifications
         * @param {boolean} [nested] show nested component instead of id
         * @param {Array<string>} [ids] choose the specific ids you wish to get
         * @param {number} [page] page of results
         * @param {number} [pageSize] number of elements to return on a page
         * @param {string} [search] search for entries that contain the substring
         * @param {string} [sort] Parameter to sort results on
         * @param {boolean} [desc] sort results by descending order (as opposed to ascending order)
         * @param {string} [userId] user id you want to filter on
         * @param {boolean} [info] display additional information about a nested relationship without displaying fully nested object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        specificationsGet: async (nested?: boolean, ids?: Array<string>, page?: number, pageSize?: number, search?: string, sort?: string, desc?: boolean, userId?: string, info?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/specifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (nested !== undefined) {
                localVarQueryParameter['nested'] = nested;
            }

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (desc !== undefined) {
                localVarQueryParameter['desc'] = desc;
            }

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }

            if (info !== undefined) {
                localVarQueryParameter['info'] = info;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get a meta-analysis specification
         * @summary Get information about a Specification
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        specificationsIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('specificationsIdGet', 'id', id)
            const localVarPath = `/specifications/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update an existing meta analysis specification
         * @summary Update Meta-Analysis specification
         * @param {string} id 
         * @param {Specification} [specification] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        specificationsIdPut: async (id: string, specification?: Specification, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('specificationsIdPut', 'id', id)
            const localVarPath = `/specifications/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JSON-Web-Token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(specification, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * create a new meta-analysis specification
         * @summary Create a Specification
         * @param {SpecificationPostBody} [specificationPostBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        specificationsPost: async (specificationPostBody?: SpecificationPostBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/specifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JSON-Web-Token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(specificationPostBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a list of Tags
         * @param {Array<string>} [ids] choose the specific ids you wish to get
         * @param {number} [page] page of results
         * @param {number} [pageSize] number of elements to return on a page
         * @param {string} [name] search the name field for a term
         * @param {string} [search] search for entries that contain the substring
         * @param {string} [filter] alias for search when filtering tags
         * @param {string} [description] search description field for a term
         * @param {string} [group] filter tags by group
         * @param {boolean} [official] filter tags by official flag
         * @param {string} [sort] Parameter to sort results on
         * @param {boolean} [desc] sort results by descending order (as opposed to ascending order)
         * @param {string} [userId] user id you want to filter on
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tagsGet: async (ids?: Array<string>, page?: number, pageSize?: number, name?: string, search?: string, filter?: string, description?: string, group?: string, official?: boolean, sort?: string, desc?: boolean, userId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/tags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JSON-Web-Token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            if (description !== undefined) {
                localVarQueryParameter['description'] = description;
            }

            if (group !== undefined) {
                localVarQueryParameter['group'] = group;
            }

            if (official !== undefined) {
                localVarQueryParameter['official'] = official;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (desc !== undefined) {
                localVarQueryParameter['desc'] = desc;
            }

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get information about a Tag
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tagsIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('tagsIdGet', 'id', id)
            const localVarPath = `/tags/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new Tag
         * @param {Tag} [tag] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tagsPost: async (tag?: Tag, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/tags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JSON-Web-Token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tag, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all users
         * @summary GET list of Users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve the information of the user with the matching user ID.
         * @summary Get User Info by User ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('usersIdGet', 'id', id)
            const localVarPath = `/users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update information about a user
         * @summary Update User Information
         * @param {string} id 
         * @param {User} [user] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersIdPut: async (id: string, user?: User, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('usersIdPut', 'id', id)
            const localVarPath = `/users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JSON-Web-Token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(user, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * create a single user
         * @summary Create A New User
         * @param {User} [user] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersPost: async (user?: User, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JSON-Web-Token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(user, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ComposeApi - functional programming interface
 */
export const ComposeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ComposeApiAxiosParamCreator(configuration)
    return {
        /**
         * list all runnable specification, studyset, annotation bundles
         * @summary GET a list of meta-analyses
         * @param {boolean} [nested] show nested component instead of id
         * @param {Array<string>} [ids] choose the specific ids you wish to get
         * @param {number} [page] page of results
         * @param {number} [pageSize] number of elements to return on a page
         * @param {string} [name] search the name field for a term
         * @param {string} [search] search for entries that contain the substring
         * @param {string} [description] search description field for a term
         * @param {string} [sort] Parameter to sort results on
         * @param {boolean} [desc] sort results by descending order (as opposed to ascending order)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async metaAnalysesGet(nested?: boolean, ids?: Array<string>, page?: number, pageSize?: number, name?: string, search?: string, description?: string, sort?: string, desc?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MetaAnalysisList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.metaAnalysesGet(nested, ids, page, pageSize, name, search, description, sort, desc, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComposeApi.metaAnalysesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * get a meta-analysis (specification, annotation, and studyset)
         * @summary GET meta-analysis information
         * @param {string} id 
         * @param {boolean} [nested] show nested component instead of id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async metaAnalysesIdGet(id: string, nested?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MetaAnalysisReturn>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.metaAnalysesIdGet(id, nested, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComposeApi.metaAnalysesIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * update an existing meta-analysis (that has not yet been run)
         * @summary Update a meta-analysis
         * @param {string} id 
         * @param {MetaAnalysis} [metaAnalysis] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async metaAnalysesIdPut(id: string, metaAnalysis?: MetaAnalysis, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MetaAnalysisReturn>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.metaAnalysesIdPut(id, metaAnalysis, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComposeApi.metaAnalysesIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * create a new specification, studyset, annotation bundle
         * @summary Create a new meta-analysis
         * @param {MetaAnalysisPostBody} [metaAnalysisPostBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async metaAnalysesPost(metaAnalysisPostBody?: MetaAnalysisPostBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MetaAnalysisReturn>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.metaAnalysesPost(metaAnalysisPostBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComposeApi.metaAnalysesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return cached job submissions associated with the authenticated user.
         * @summary List meta-analysis jobs for the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async metaAnalysisJobsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MetaAnalysisJobList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.metaAnalysisJobsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComposeApi.metaAnalysisJobsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve the most recent status information and logs for a submitted job.
         * @summary Get status and logs for a meta-analysis job
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async metaAnalysisJobsJobIdGet(jobId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MetaAnalysisJobResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.metaAnalysisJobsJobIdGet(jobId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComposeApi.metaAnalysisJobsJobIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Submit a meta-analysis to the compose runner service.
         * @summary Submit a meta-analysis job
         * @param {MetaAnalysisJobRequest} metaAnalysisJobRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async metaAnalysisJobsPost(metaAnalysisJobRequest: MetaAnalysisJobRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MetaAnalysisJobResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.metaAnalysisJobsPost(metaAnalysisJobRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComposeApi.metaAnalysisJobsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List meta-analysis results
         * @param {string} [metaAnalysisId] search for results with this meta-analysis id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async metaAnalysisResultsGet(metaAnalysisId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.metaAnalysisResultsGet(metaAnalysisId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComposeApi.metaAnalysisResultsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a meta-analysis result by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async metaAnalysisResultsIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultReturn>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.metaAnalysisResultsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComposeApi.metaAnalysisResultsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a meta-analysis result with files or snapshots
         * @param {string} id 
         * @param {ResultUploadStatisticalMaps} [statisticalMaps] 
         * @param {ResultUploadStatisticalMaps} [clusterTables] 
         * @param {ResultUploadStatisticalMaps} [diagnosticTables] 
         * @param {string} [methodDescription] the description of the methods applied to create this result.
         * @param {string} [methodReferences] BibTeX-formatted references cited by method_description. 
         * @param {string} [snapshotStudyset] JSON-encoded studyset snapshot payload, optionally provided in multipart form.
         * @param {string} [snapshotAnnotation] JSON-encoded annotation snapshot payload, optionally provided in multipart form.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async metaAnalysisResultsIdPut(id: string, statisticalMaps?: ResultUploadStatisticalMaps, clusterTables?: ResultUploadStatisticalMaps, diagnosticTables?: ResultUploadStatisticalMaps, methodDescription?: string, methodReferences?: string, snapshotStudyset?: string, snapshotAnnotation?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultReturn>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.metaAnalysisResultsIdPut(id, statisticalMaps, clusterTables, diagnosticTables, methodDescription, methodReferences, snapshotStudyset, snapshotAnnotation, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComposeApi.metaAnalysisResultsIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a new meta-analysis result
         * @param {ResultInit} [resultInit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async metaAnalysisResultsPost(resultInit?: ResultInit, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultReturn>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.metaAnalysisResultsPost(resultInit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComposeApi.metaAnalysisResultsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Resolve a Neurostore annotation reference using the same ID exposed by the Neurostore API, including each linked snapshot\'s compose ID and md5.
         * @summary Get a Neurostore annotation reference by Neurostore ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async neurostoreAnnotationsIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AnnotationReferenceReturn>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.neurostoreAnnotationsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComposeApi.neurostoreAnnotationsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Your GET endpoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async neurostoreStudiesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NeurostoreStudyList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.neurostoreStudiesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComposeApi.neurostoreStudiesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Your GET endpoint
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async neurostoreStudiesIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NeurostoreStudyReturn>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.neurostoreStudiesIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComposeApi.neurostoreStudiesIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List reference rows keyed by the actual Neurostore studyset ID, including compact snapshot summaries.
         * @summary List Neurostore studyset references
         * @param {boolean} [nested] show nested component instead of id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async neurostoreStudysetsGet(nested?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StudysetReferenceList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.neurostoreStudysetsGet(nested, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComposeApi.neurostoreStudysetsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Resolve a Neurostore studyset reference using the same ID exposed by the Neurostore API, including each linked snapshot\'s compose ID and md5.
         * @summary Get a Neurostore studyset reference by Neurostore ID
         * @param {string} id 
         * @param {boolean} [nested] show nested component instead of id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async neurostoreStudysetsIdGet(id: string, nested?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StudysetReferenceReturn>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.neurostoreStudysetsIdGet(id, nested, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComposeApi.neurostoreStudysetsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get neurovault collections
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async neurovaultCollectionsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.neurovaultCollectionsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComposeApi.neurovaultCollectionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Your GET endpoint
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async neurovaultCollectionsIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NeurovaultCollectionReturn>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.neurovaultCollectionsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComposeApi.neurovaultCollectionsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async neurovaultCollectionsIdPut(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NeurovaultCollectionReturn>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.neurovaultCollectionsIdPut(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComposeApi.neurovaultCollectionsIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create neurovault collection
         * @param {NeurovaultCollection} [neurovaultCollection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async neurovaultCollectionsPost(neurovaultCollection?: NeurovaultCollection, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.neurovaultCollectionsPost(neurovaultCollection, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComposeApi.neurovaultCollectionsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Your GET endpoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async neurovaultFilesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NeurovaultFileList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.neurovaultFilesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComposeApi.neurovaultFilesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Your GET endpoint
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async neurovaultFilesIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NeurovaultFileReturn>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.neurovaultFilesIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComposeApi.neurovaultFilesIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {string | null} [collectionId] 
         * @param {string | null} [exception] 
         * @param {string | null} [traceback] 
         * @param {string} [status] 
         * @param {string | null} [imageId] 
         * @param {string | null} [name] 
         * @param {string | null} [url] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async neurovaultFilesIdPut(id: string, collectionId?: string | null, exception?: string | null, traceback?: string | null, status?: string, imageId?: string | null, name?: string | null, url?: string | null, file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NeurovaultFileReturn>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.neurovaultFilesIdPut(id, collectionId, exception, traceback, status, imageId, name, url, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComposeApi.neurovaultFilesIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {NeurovaultFile} [neurovaultFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async neurovaultFilesPost(neurovaultFile?: NeurovaultFile, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NeurovaultFileReturn>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.neurovaultFilesPost(neurovaultFile, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComposeApi.neurovaultFilesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Your GET endpoint
         * @param {number} [page] page of results
         * @param {number} [pageSize] number of elements to return on a page
         * @param {string} [name] search the name field for a term
         * @param {string} [search] search for entries that contain the substring
         * @param {string} [description] search description field for a term
         * @param {string} [sort] Parameter to sort results on
         * @param {boolean} [desc] sort results by descending order (as opposed to ascending order)
         * @param {string} [userId] user id you want to filter on
         * @param {boolean} [includeProvenance] include the project provenance payload in project responses
         * @param {Array<string>} [tag] only return projects carrying every one of these tag names (case-insensitive)
         * @param {Array<string>} [excludeTag] drop projects carrying any of these tag names (case-insensitive); use this to hide projects a user has tagged away
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async projectsGet(page?: number, pageSize?: number, name?: string, search?: string, description?: string, sort?: string, desc?: boolean, userId?: string, includeProvenance?: boolean, tag?: Array<string>, excludeTag?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.projectsGet(page, pageSize, name, search, description, sort, desc, userId, includeProvenance, tag, excludeTag, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComposeApi.projectsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async projectsIdDelete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.projectsIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComposeApi.projectsIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Your GET endpoint
         * @param {string} id 
         * @param {boolean} [info] display additional information about a nested relationship without displaying fully nested object
         * @param {boolean} [includeProvenance] include the project provenance payload in project responses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async projectsIdGet(id: string, info?: boolean, includeProvenance?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectReturn>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.projectsIdGet(id, info, includeProvenance, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComposeApi.projectsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {boolean} [syncMetaAnalysesPublic] when updating a project\&#39;s public flag, also set each child meta-analysis to the same public value
         * @param {Project} [project] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async projectsIdPut(id: string, syncMetaAnalysesPublic?: boolean, project?: Project, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectReturn>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.projectsIdPut(id, syncMetaAnalysesPublic, project, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComposeApi.projectsIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {string} [sourceId] clone an existing project when creating a new project
         * @param {boolean} [copyAnnotations] when cloning via &#x60;source_id&#x60;, also duplicate associated annotations
         * @param {Project} [project] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async projectsPost(sourceId?: string, copyAnnotations?: boolean, project?: Project, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectReturn>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.projectsPost(sourceId, copyAnnotations, project, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComposeApi.projectsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * get a list of serialized/referenced annotations
         * @summary GET a list of annotations
         * @param {boolean} [nested] show nested component instead of id
         * @param {Array<string>} [ids] choose the specific ids you wish to get
         * @param {number} [page] page of results
         * @param {number} [pageSize] number of elements to return on a page
         * @param {string} [search] search for entries that contain the substring
         * @param {string} [sort] Parameter to sort results on
         * @param {boolean} [desc] sort results by descending order (as opposed to ascending order)
         * @param {string} [userId] user id you want to filter on
         * @param {boolean} [info] display additional information about a nested relationship without displaying fully nested object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async snapshotAnnotationsGet(nested?: boolean, ids?: Array<string>, page?: number, pageSize?: number, search?: string, sort?: string, desc?: boolean, userId?: string, info?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AnnotationList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.snapshotAnnotationsGet(nested, ids, page, pageSize, search, sort, desc, userId, info, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComposeApi.snapshotAnnotationsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * get a single annotation
         * @summary GET information about an annotation
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async snapshotAnnotationsIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AnnotationReturn>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.snapshotAnnotationsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComposeApi.snapshotAnnotationsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * update an existing annotation
         * @summary Update an Annotation
         * @param {string} id 
         * @param {AnnotationUpdate} [annotationUpdate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async snapshotAnnotationsIdPut(id: string, annotationUpdate?: AnnotationUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AnnotationReturn>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.snapshotAnnotationsIdPut(id, annotationUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComposeApi.snapshotAnnotationsIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * create a new serialized/referenced annotation
         * @summary Create a new Annotation
         * @param {AnnotationPostBody} [annotationPostBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async snapshotAnnotationsPost(annotationPostBody?: AnnotationPostBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AnnotationReturn>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.snapshotAnnotationsPost(annotationPostBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComposeApi.snapshotAnnotationsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * get a list of serialized/referenced studysets
         * @summary Get a list of Studysets
         * @param {boolean} [nested] show nested component instead of id
         * @param {Array<string>} [ids] choose the specific ids you wish to get
         * @param {number} [page] page of results
         * @param {number} [pageSize] number of elements to return on a page
         * @param {string} [search] search for entries that contain the substring
         * @param {string} [sort] Parameter to sort results on
         * @param {boolean} [desc] sort results by descending order (as opposed to ascending order)
         * @param {string} [userId] user id you want to filter on
         * @param {boolean} [info] display additional information about a nested relationship without displaying fully nested object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async snapshotStudysetsGet(nested?: boolean, ids?: Array<string>, page?: number, pageSize?: number, search?: string, sort?: string, desc?: boolean, userId?: string, info?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StudysetList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.snapshotStudysetsGet(nested, ids, page, pageSize, search, sort, desc, userId, info, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComposeApi.snapshotStudysetsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * get a single serialized/referenced studyset
         * @summary Get information about a Studyset
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async snapshotStudysetsIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StudysetReturn>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.snapshotStudysetsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComposeApi.snapshotStudysetsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * update an existing serialized/referenced studyset
         * @summary Update a Studyset
         * @param {string} id 
         * @param {Studyset} [studyset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async snapshotStudysetsIdPut(id: string, studyset?: Studyset, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StudysetReturn>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.snapshotStudysetsIdPut(id, studyset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComposeApi.snapshotStudysetsIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * create a new serialized/referenced studyset
         * @summary Create a new Studyset
         * @param {StudysetPostBody} [studysetPostBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async snapshotStudysetsPost(studysetPostBody?: StudysetPostBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StudysetReturn>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.snapshotStudysetsPost(studysetPostBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComposeApi.snapshotStudysetsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * list of meta-analysis specifications
         * @summary Get a list of Specifications
         * @param {boolean} [nested] show nested component instead of id
         * @param {Array<string>} [ids] choose the specific ids you wish to get
         * @param {number} [page] page of results
         * @param {number} [pageSize] number of elements to return on a page
         * @param {string} [search] search for entries that contain the substring
         * @param {string} [sort] Parameter to sort results on
         * @param {boolean} [desc] sort results by descending order (as opposed to ascending order)
         * @param {string} [userId] user id you want to filter on
         * @param {boolean} [info] display additional information about a nested relationship without displaying fully nested object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async specificationsGet(nested?: boolean, ids?: Array<string>, page?: number, pageSize?: number, search?: string, sort?: string, desc?: boolean, userId?: string, info?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SpecificationList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.specificationsGet(nested, ids, page, pageSize, search, sort, desc, userId, info, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComposeApi.specificationsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * get a meta-analysis specification
         * @summary Get information about a Specification
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async specificationsIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SpecificationReturn>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.specificationsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComposeApi.specificationsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * update an existing meta analysis specification
         * @summary Update Meta-Analysis specification
         * @param {string} id 
         * @param {Specification} [specification] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async specificationsIdPut(id: string, specification?: Specification, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SpecificationReturn>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.specificationsIdPut(id, specification, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComposeApi.specificationsIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * create a new meta-analysis specification
         * @summary Create a Specification
         * @param {SpecificationPostBody} [specificationPostBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async specificationsPost(specificationPostBody?: SpecificationPostBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SpecificationReturn>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.specificationsPost(specificationPostBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComposeApi.specificationsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a list of Tags
         * @param {Array<string>} [ids] choose the specific ids you wish to get
         * @param {number} [page] page of results
         * @param {number} [pageSize] number of elements to return on a page
         * @param {string} [name] search the name field for a term
         * @param {string} [search] search for entries that contain the substring
         * @param {string} [filter] alias for search when filtering tags
         * @param {string} [description] search description field for a term
         * @param {string} [group] filter tags by group
         * @param {boolean} [official] filter tags by official flag
         * @param {string} [sort] Parameter to sort results on
         * @param {boolean} [desc] sort results by descending order (as opposed to ascending order)
         * @param {string} [userId] user id you want to filter on
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tagsGet(ids?: Array<string>, page?: number, pageSize?: number, name?: string, search?: string, filter?: string, description?: string, group?: string, official?: boolean, sort?: string, desc?: boolean, userId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TagList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tagsGet(ids, page, pageSize, name, search, filter, description, group, official, sort, desc, userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComposeApi.tagsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get information about a Tag
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tagsIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TagReturn>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tagsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComposeApi.tagsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a new Tag
         * @param {Tag} [tag] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tagsPost(tag?: Tag, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TagReturn>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tagsPost(tag, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComposeApi.tagsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all users
         * @summary GET list of Users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComposeApi.usersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve the information of the user with the matching user ID.
         * @summary Get User Info by User ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserReturn>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComposeApi.usersIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * update information about a user
         * @summary Update User Information
         * @param {string} id 
         * @param {User} [user] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersIdPut(id: string, user?: User, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserReturn>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersIdPut(id, user, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComposeApi.usersIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * create a single user
         * @summary Create A New User
         * @param {User} [user] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersPost(user?: User, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserReturn>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersPost(user, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComposeApi.usersPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ComposeApi - factory interface
 */
export const ComposeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ComposeApiFp(configuration)
    return {
        /**
         * list all runnable specification, studyset, annotation bundles
         * @summary GET a list of meta-analyses
         * @param {boolean} [nested] show nested component instead of id
         * @param {Array<string>} [ids] choose the specific ids you wish to get
         * @param {number} [page] page of results
         * @param {number} [pageSize] number of elements to return on a page
         * @param {string} [name] search the name field for a term
         * @param {string} [search] search for entries that contain the substring
         * @param {string} [description] search description field for a term
         * @param {string} [sort] Parameter to sort results on
         * @param {boolean} [desc] sort results by descending order (as opposed to ascending order)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metaAnalysesGet(nested?: boolean, ids?: Array<string>, page?: number, pageSize?: number, name?: string, search?: string, description?: string, sort?: string, desc?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<MetaAnalysisList> {
            return localVarFp.metaAnalysesGet(nested, ids, page, pageSize, name, search, description, sort, desc, options).then((request) => request(axios, basePath));
        },
        /**
         * get a meta-analysis (specification, annotation, and studyset)
         * @summary GET meta-analysis information
         * @param {string} id 
         * @param {boolean} [nested] show nested component instead of id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metaAnalysesIdGet(id: string, nested?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<MetaAnalysisReturn> {
            return localVarFp.metaAnalysesIdGet(id, nested, options).then((request) => request(axios, basePath));
        },
        /**
         * update an existing meta-analysis (that has not yet been run)
         * @summary Update a meta-analysis
         * @param {string} id 
         * @param {MetaAnalysis} [metaAnalysis] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metaAnalysesIdPut(id: string, metaAnalysis?: MetaAnalysis, options?: RawAxiosRequestConfig): AxiosPromise<MetaAnalysisReturn> {
            return localVarFp.metaAnalysesIdPut(id, metaAnalysis, options).then((request) => request(axios, basePath));
        },
        /**
         * create a new specification, studyset, annotation bundle
         * @summary Create a new meta-analysis
         * @param {MetaAnalysisPostBody} [metaAnalysisPostBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metaAnalysesPost(metaAnalysisPostBody?: MetaAnalysisPostBody, options?: RawAxiosRequestConfig): AxiosPromise<MetaAnalysisReturn> {
            return localVarFp.metaAnalysesPost(metaAnalysisPostBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Return cached job submissions associated with the authenticated user.
         * @summary List meta-analysis jobs for the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metaAnalysisJobsGet(options?: RawAxiosRequestConfig): AxiosPromise<MetaAnalysisJobList> {
            return localVarFp.metaAnalysisJobsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the most recent status information and logs for a submitted job.
         * @summary Get status and logs for a meta-analysis job
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metaAnalysisJobsJobIdGet(jobId: string, options?: RawAxiosRequestConfig): AxiosPromise<MetaAnalysisJobResponse> {
            return localVarFp.metaAnalysisJobsJobIdGet(jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * Submit a meta-analysis to the compose runner service.
         * @summary Submit a meta-analysis job
         * @param {MetaAnalysisJobRequest} metaAnalysisJobRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metaAnalysisJobsPost(metaAnalysisJobRequest: MetaAnalysisJobRequest, options?: RawAxiosRequestConfig): AxiosPromise<MetaAnalysisJobResponse> {
            return localVarFp.metaAnalysisJobsPost(metaAnalysisJobRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List meta-analysis results
         * @param {string} [metaAnalysisId] search for results with this meta-analysis id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metaAnalysisResultsGet(metaAnalysisId?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResultList> {
            return localVarFp.metaAnalysisResultsGet(metaAnalysisId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a meta-analysis result by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metaAnalysisResultsIdGet(id: string, options?: RawAxiosRequestConfig): AxiosPromise<ResultReturn> {
            return localVarFp.metaAnalysisResultsIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a meta-analysis result with files or snapshots
         * @param {string} id 
         * @param {ResultUploadStatisticalMaps} [statisticalMaps] 
         * @param {ResultUploadStatisticalMaps} [clusterTables] 
         * @param {ResultUploadStatisticalMaps} [diagnosticTables] 
         * @param {string} [methodDescription] the description of the methods applied to create this result.
         * @param {string} [methodReferences] BibTeX-formatted references cited by method_description. 
         * @param {string} [snapshotStudyset] JSON-encoded studyset snapshot payload, optionally provided in multipart form.
         * @param {string} [snapshotAnnotation] JSON-encoded annotation snapshot payload, optionally provided in multipart form.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metaAnalysisResultsIdPut(id: string, statisticalMaps?: ResultUploadStatisticalMaps, clusterTables?: ResultUploadStatisticalMaps, diagnosticTables?: ResultUploadStatisticalMaps, methodDescription?: string, methodReferences?: string, snapshotStudyset?: string, snapshotAnnotation?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResultReturn> {
            return localVarFp.metaAnalysisResultsIdPut(id, statisticalMaps, clusterTables, diagnosticTables, methodDescription, methodReferences, snapshotStudyset, snapshotAnnotation, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new meta-analysis result
         * @param {ResultInit} [resultInit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metaAnalysisResultsPost(resultInit?: ResultInit, options?: RawAxiosRequestConfig): AxiosPromise<ResultReturn> {
            return localVarFp.metaAnalysisResultsPost(resultInit, options).then((request) => request(axios, basePath));
        },
        /**
         * Resolve a Neurostore annotation reference using the same ID exposed by the Neurostore API, including each linked snapshot\'s compose ID and md5.
         * @summary Get a Neurostore annotation reference by Neurostore ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        neurostoreAnnotationsIdGet(id: string, options?: RawAxiosRequestConfig): AxiosPromise<AnnotationReferenceReturn> {
            return localVarFp.neurostoreAnnotationsIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Your GET endpoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        neurostoreStudiesGet(options?: RawAxiosRequestConfig): AxiosPromise<NeurostoreStudyList> {
            return localVarFp.neurostoreStudiesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Your GET endpoint
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        neurostoreStudiesIdGet(id: string, options?: RawAxiosRequestConfig): AxiosPromise<NeurostoreStudyReturn> {
            return localVarFp.neurostoreStudiesIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * List reference rows keyed by the actual Neurostore studyset ID, including compact snapshot summaries.
         * @summary List Neurostore studyset references
         * @param {boolean} [nested] show nested component instead of id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        neurostoreStudysetsGet(nested?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<StudysetReferenceList> {
            return localVarFp.neurostoreStudysetsGet(nested, options).then((request) => request(axios, basePath));
        },
        /**
         * Resolve a Neurostore studyset reference using the same ID exposed by the Neurostore API, including each linked snapshot\'s compose ID and md5.
         * @summary Get a Neurostore studyset reference by Neurostore ID
         * @param {string} id 
         * @param {boolean} [nested] show nested component instead of id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        neurostoreStudysetsIdGet(id: string, nested?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<StudysetReferenceReturn> {
            return localVarFp.neurostoreStudysetsIdGet(id, nested, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get neurovault collections
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        neurovaultCollectionsGet(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.neurovaultCollectionsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Your GET endpoint
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        neurovaultCollectionsIdGet(id: string, options?: RawAxiosRequestConfig): AxiosPromise<NeurovaultCollectionReturn> {
            return localVarFp.neurovaultCollectionsIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        neurovaultCollectionsIdPut(id: string, options?: RawAxiosRequestConfig): AxiosPromise<NeurovaultCollectionReturn> {
            return localVarFp.neurovaultCollectionsIdPut(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create neurovault collection
         * @param {NeurovaultCollection} [neurovaultCollection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        neurovaultCollectionsPost(neurovaultCollection?: NeurovaultCollection, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.neurovaultCollectionsPost(neurovaultCollection, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Your GET endpoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        neurovaultFilesGet(options?: RawAxiosRequestConfig): AxiosPromise<NeurovaultFileList> {
            return localVarFp.neurovaultFilesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Your GET endpoint
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        neurovaultFilesIdGet(id: string, options?: RawAxiosRequestConfig): AxiosPromise<NeurovaultFileReturn> {
            return localVarFp.neurovaultFilesIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {string | null} [collectionId] 
         * @param {string | null} [exception] 
         * @param {string | null} [traceback] 
         * @param {string} [status] 
         * @param {string | null} [imageId] 
         * @param {string | null} [name] 
         * @param {string | null} [url] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        neurovaultFilesIdPut(id: string, collectionId?: string | null, exception?: string | null, traceback?: string | null, status?: string, imageId?: string | null, name?: string | null, url?: string | null, file?: File, options?: RawAxiosRequestConfig): AxiosPromise<NeurovaultFileReturn> {
            return localVarFp.neurovaultFilesIdPut(id, collectionId, exception, traceback, status, imageId, name, url, file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {NeurovaultFile} [neurovaultFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        neurovaultFilesPost(neurovaultFile?: NeurovaultFile, options?: RawAxiosRequestConfig): AxiosPromise<NeurovaultFileReturn> {
            return localVarFp.neurovaultFilesPost(neurovaultFile, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Your GET endpoint
         * @param {number} [page] page of results
         * @param {number} [pageSize] number of elements to return on a page
         * @param {string} [name] search the name field for a term
         * @param {string} [search] search for entries that contain the substring
         * @param {string} [description] search description field for a term
         * @param {string} [sort] Parameter to sort results on
         * @param {boolean} [desc] sort results by descending order (as opposed to ascending order)
         * @param {string} [userId] user id you want to filter on
         * @param {boolean} [includeProvenance] include the project provenance payload in project responses
         * @param {Array<string>} [tag] only return projects carrying every one of these tag names (case-insensitive)
         * @param {Array<string>} [excludeTag] drop projects carrying any of these tag names (case-insensitive); use this to hide projects a user has tagged away
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectsGet(page?: number, pageSize?: number, name?: string, search?: string, description?: string, sort?: string, desc?: boolean, userId?: string, includeProvenance?: boolean, tag?: Array<string>, excludeTag?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<ProjectList> {
            return localVarFp.projectsGet(page, pageSize, name, search, description, sort, desc, userId, includeProvenance, tag, excludeTag, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectsIdDelete(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.projectsIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Your GET endpoint
         * @param {string} id 
         * @param {boolean} [info] display additional information about a nested relationship without displaying fully nested object
         * @param {boolean} [includeProvenance] include the project provenance payload in project responses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectsIdGet(id: string, info?: boolean, includeProvenance?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<ProjectReturn> {
            return localVarFp.projectsIdGet(id, info, includeProvenance, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {boolean} [syncMetaAnalysesPublic] when updating a project\&#39;s public flag, also set each child meta-analysis to the same public value
         * @param {Project} [project] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectsIdPut(id: string, syncMetaAnalysesPublic?: boolean, project?: Project, options?: RawAxiosRequestConfig): AxiosPromise<ProjectReturn> {
            return localVarFp.projectsIdPut(id, syncMetaAnalysesPublic, project, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} [sourceId] clone an existing project when creating a new project
         * @param {boolean} [copyAnnotations] when cloning via &#x60;source_id&#x60;, also duplicate associated annotations
         * @param {Project} [project] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectsPost(sourceId?: string, copyAnnotations?: boolean, project?: Project, options?: RawAxiosRequestConfig): AxiosPromise<ProjectReturn> {
            return localVarFp.projectsPost(sourceId, copyAnnotations, project, options).then((request) => request(axios, basePath));
        },
        /**
         * get a list of serialized/referenced annotations
         * @summary GET a list of annotations
         * @param {boolean} [nested] show nested component instead of id
         * @param {Array<string>} [ids] choose the specific ids you wish to get
         * @param {number} [page] page of results
         * @param {number} [pageSize] number of elements to return on a page
         * @param {string} [search] search for entries that contain the substring
         * @param {string} [sort] Parameter to sort results on
         * @param {boolean} [desc] sort results by descending order (as opposed to ascending order)
         * @param {string} [userId] user id you want to filter on
         * @param {boolean} [info] display additional information about a nested relationship without displaying fully nested object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snapshotAnnotationsGet(nested?: boolean, ids?: Array<string>, page?: number, pageSize?: number, search?: string, sort?: string, desc?: boolean, userId?: string, info?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<AnnotationList> {
            return localVarFp.snapshotAnnotationsGet(nested, ids, page, pageSize, search, sort, desc, userId, info, options).then((request) => request(axios, basePath));
        },
        /**
         * get a single annotation
         * @summary GET information about an annotation
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snapshotAnnotationsIdGet(id: string, options?: RawAxiosRequestConfig): AxiosPromise<AnnotationReturn> {
            return localVarFp.snapshotAnnotationsIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * update an existing annotation
         * @summary Update an Annotation
         * @param {string} id 
         * @param {AnnotationUpdate} [annotationUpdate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snapshotAnnotationsIdPut(id: string, annotationUpdate?: AnnotationUpdate, options?: RawAxiosRequestConfig): AxiosPromise<AnnotationReturn> {
            return localVarFp.snapshotAnnotationsIdPut(id, annotationUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * create a new serialized/referenced annotation
         * @summary Create a new Annotation
         * @param {AnnotationPostBody} [annotationPostBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snapshotAnnotationsPost(annotationPostBody?: AnnotationPostBody, options?: RawAxiosRequestConfig): AxiosPromise<AnnotationReturn> {
            return localVarFp.snapshotAnnotationsPost(annotationPostBody, options).then((request) => request(axios, basePath));
        },
        /**
         * get a list of serialized/referenced studysets
         * @summary Get a list of Studysets
         * @param {boolean} [nested] show nested component instead of id
         * @param {Array<string>} [ids] choose the specific ids you wish to get
         * @param {number} [page] page of results
         * @param {number} [pageSize] number of elements to return on a page
         * @param {string} [search] search for entries that contain the substring
         * @param {string} [sort] Parameter to sort results on
         * @param {boolean} [desc] sort results by descending order (as opposed to ascending order)
         * @param {string} [userId] user id you want to filter on
         * @param {boolean} [info] display additional information about a nested relationship without displaying fully nested object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snapshotStudysetsGet(nested?: boolean, ids?: Array<string>, page?: number, pageSize?: number, search?: string, sort?: string, desc?: boolean, userId?: string, info?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<StudysetList> {
            return localVarFp.snapshotStudysetsGet(nested, ids, page, pageSize, search, sort, desc, userId, info, options).then((request) => request(axios, basePath));
        },
        /**
         * get a single serialized/referenced studyset
         * @summary Get information about a Studyset
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snapshotStudysetsIdGet(id: string, options?: RawAxiosRequestConfig): AxiosPromise<StudysetReturn> {
            return localVarFp.snapshotStudysetsIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * update an existing serialized/referenced studyset
         * @summary Update a Studyset
         * @param {string} id 
         * @param {Studyset} [studyset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snapshotStudysetsIdPut(id: string, studyset?: Studyset, options?: RawAxiosRequestConfig): AxiosPromise<StudysetReturn> {
            return localVarFp.snapshotStudysetsIdPut(id, studyset, options).then((request) => request(axios, basePath));
        },
        /**
         * create a new serialized/referenced studyset
         * @summary Create a new Studyset
         * @param {StudysetPostBody} [studysetPostBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snapshotStudysetsPost(studysetPostBody?: StudysetPostBody, options?: RawAxiosRequestConfig): AxiosPromise<StudysetReturn> {
            return localVarFp.snapshotStudysetsPost(studysetPostBody, options).then((request) => request(axios, basePath));
        },
        /**
         * list of meta-analysis specifications
         * @summary Get a list of Specifications
         * @param {boolean} [nested] show nested component instead of id
         * @param {Array<string>} [ids] choose the specific ids you wish to get
         * @param {number} [page] page of results
         * @param {number} [pageSize] number of elements to return on a page
         * @param {string} [search] search for entries that contain the substring
         * @param {string} [sort] Parameter to sort results on
         * @param {boolean} [desc] sort results by descending order (as opposed to ascending order)
         * @param {string} [userId] user id you want to filter on
         * @param {boolean} [info] display additional information about a nested relationship without displaying fully nested object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        specificationsGet(nested?: boolean, ids?: Array<string>, page?: number, pageSize?: number, search?: string, sort?: string, desc?: boolean, userId?: string, info?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<SpecificationList> {
            return localVarFp.specificationsGet(nested, ids, page, pageSize, search, sort, desc, userId, info, options).then((request) => request(axios, basePath));
        },
        /**
         * get a meta-analysis specification
         * @summary Get information about a Specification
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        specificationsIdGet(id: string, options?: RawAxiosRequestConfig): AxiosPromise<SpecificationReturn> {
            return localVarFp.specificationsIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * update an existing meta analysis specification
         * @summary Update Meta-Analysis specification
         * @param {string} id 
         * @param {Specification} [specification] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        specificationsIdPut(id: string, specification?: Specification, options?: RawAxiosRequestConfig): AxiosPromise<SpecificationReturn> {
            return localVarFp.specificationsIdPut(id, specification, options).then((request) => request(axios, basePath));
        },
        /**
         * create a new meta-analysis specification
         * @summary Create a Specification
         * @param {SpecificationPostBody} [specificationPostBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        specificationsPost(specificationPostBody?: SpecificationPostBody, options?: RawAxiosRequestConfig): AxiosPromise<SpecificationReturn> {
            return localVarFp.specificationsPost(specificationPostBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a list of Tags
         * @param {Array<string>} [ids] choose the specific ids you wish to get
         * @param {number} [page] page of results
         * @param {number} [pageSize] number of elements to return on a page
         * @param {string} [name] search the name field for a term
         * @param {string} [search] search for entries that contain the substring
         * @param {string} [filter] alias for search when filtering tags
         * @param {string} [description] search description field for a term
         * @param {string} [group] filter tags by group
         * @param {boolean} [official] filter tags by official flag
         * @param {string} [sort] Parameter to sort results on
         * @param {boolean} [desc] sort results by descending order (as opposed to ascending order)
         * @param {string} [userId] user id you want to filter on
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tagsGet(ids?: Array<string>, page?: number, pageSize?: number, name?: string, search?: string, filter?: string, description?: string, group?: string, official?: boolean, sort?: string, desc?: boolean, userId?: string, options?: RawAxiosRequestConfig): AxiosPromise<TagList> {
            return localVarFp.tagsGet(ids, page, pageSize, name, search, filter, description, group, official, sort, desc, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get information about a Tag
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tagsIdGet(id: string, options?: RawAxiosRequestConfig): AxiosPromise<TagReturn> {
            return localVarFp.tagsIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new Tag
         * @param {Tag} [tag] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tagsPost(tag?: Tag, options?: RawAxiosRequestConfig): AxiosPromise<TagReturn> {
            return localVarFp.tagsPost(tag, options).then((request) => request(axios, basePath));
        },
        /**
         * List all users
         * @summary GET list of Users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersGet(options?: RawAxiosRequestConfig): AxiosPromise<UserList> {
            return localVarFp.usersGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the information of the user with the matching user ID.
         * @summary Get User Info by User ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersIdGet(id: string, options?: RawAxiosRequestConfig): AxiosPromise<UserReturn> {
            return localVarFp.usersIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * update information about a user
         * @summary Update User Information
         * @param {string} id 
         * @param {User} [user] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersIdPut(id: string, user?: User, options?: RawAxiosRequestConfig): AxiosPromise<UserReturn> {
            return localVarFp.usersIdPut(id, user, options).then((request) => request(axios, basePath));
        },
        /**
         * create a single user
         * @summary Create A New User
         * @param {User} [user] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersPost(user?: User, options?: RawAxiosRequestConfig): AxiosPromise<UserReturn> {
            return localVarFp.usersPost(user, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ComposeApi - object-oriented interface
 */
export class ComposeApi extends BaseAPI {
    /**
     * list all runnable specification, studyset, annotation bundles
     * @summary GET a list of meta-analyses
     * @param {boolean} [nested] show nested component instead of id
     * @param {Array<string>} [ids] choose the specific ids you wish to get
     * @param {number} [page] page of results
     * @param {number} [pageSize] number of elements to return on a page
     * @param {string} [name] search the name field for a term
     * @param {string} [search] search for entries that contain the substring
     * @param {string} [description] search description field for a term
     * @param {string} [sort] Parameter to sort results on
     * @param {boolean} [desc] sort results by descending order (as opposed to ascending order)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public metaAnalysesGet(nested?: boolean, ids?: Array<string>, page?: number, pageSize?: number, name?: string, search?: string, description?: string, sort?: string, desc?: boolean, options?: RawAxiosRequestConfig) {
        return ComposeApiFp(this.configuration).metaAnalysesGet(nested, ids, page, pageSize, name, search, description, sort, desc, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get a meta-analysis (specification, annotation, and studyset)
     * @summary GET meta-analysis information
     * @param {string} id 
     * @param {boolean} [nested] show nested component instead of id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public metaAnalysesIdGet(id: string, nested?: boolean, options?: RawAxiosRequestConfig) {
        return ComposeApiFp(this.configuration).metaAnalysesIdGet(id, nested, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * update an existing meta-analysis (that has not yet been run)
     * @summary Update a meta-analysis
     * @param {string} id 
     * @param {MetaAnalysis} [metaAnalysis] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public metaAnalysesIdPut(id: string, metaAnalysis?: MetaAnalysis, options?: RawAxiosRequestConfig) {
        return ComposeApiFp(this.configuration).metaAnalysesIdPut(id, metaAnalysis, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * create a new specification, studyset, annotation bundle
     * @summary Create a new meta-analysis
     * @param {MetaAnalysisPostBody} [metaAnalysisPostBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public metaAnalysesPost(metaAnalysisPostBody?: MetaAnalysisPostBody, options?: RawAxiosRequestConfig) {
        return ComposeApiFp(this.configuration).metaAnalysesPost(metaAnalysisPostBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return cached job submissions associated with the authenticated user.
     * @summary List meta-analysis jobs for the current user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public metaAnalysisJobsGet(options?: RawAxiosRequestConfig) {
        return ComposeApiFp(this.configuration).metaAnalysisJobsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve the most recent status information and logs for a submitted job.
     * @summary Get status and logs for a meta-analysis job
     * @param {string} jobId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public metaAnalysisJobsJobIdGet(jobId: string, options?: RawAxiosRequestConfig) {
        return ComposeApiFp(this.configuration).metaAnalysisJobsJobIdGet(jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Submit a meta-analysis to the compose runner service.
     * @summary Submit a meta-analysis job
     * @param {MetaAnalysisJobRequest} metaAnalysisJobRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public metaAnalysisJobsPost(metaAnalysisJobRequest: MetaAnalysisJobRequest, options?: RawAxiosRequestConfig) {
        return ComposeApiFp(this.configuration).metaAnalysisJobsPost(metaAnalysisJobRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List meta-analysis results
     * @param {string} [metaAnalysisId] search for results with this meta-analysis id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public metaAnalysisResultsGet(metaAnalysisId?: string, options?: RawAxiosRequestConfig) {
        return ComposeApiFp(this.configuration).metaAnalysisResultsGet(metaAnalysisId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a meta-analysis result by ID
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public metaAnalysisResultsIdGet(id: string, options?: RawAxiosRequestConfig) {
        return ComposeApiFp(this.configuration).metaAnalysisResultsIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a meta-analysis result with files or snapshots
     * @param {string} id 
     * @param {ResultUploadStatisticalMaps} [statisticalMaps] 
     * @param {ResultUploadStatisticalMaps} [clusterTables] 
     * @param {ResultUploadStatisticalMaps} [diagnosticTables] 
     * @param {string} [methodDescription] the description of the methods applied to create this result.
     * @param {string} [methodReferences] BibTeX-formatted references cited by method_description. 
     * @param {string} [snapshotStudyset] JSON-encoded studyset snapshot payload, optionally provided in multipart form.
     * @param {string} [snapshotAnnotation] JSON-encoded annotation snapshot payload, optionally provided in multipart form.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public metaAnalysisResultsIdPut(id: string, statisticalMaps?: ResultUploadStatisticalMaps, clusterTables?: ResultUploadStatisticalMaps, diagnosticTables?: ResultUploadStatisticalMaps, methodDescription?: string, methodReferences?: string, snapshotStudyset?: string, snapshotAnnotation?: string, options?: RawAxiosRequestConfig) {
        return ComposeApiFp(this.configuration).metaAnalysisResultsIdPut(id, statisticalMaps, clusterTables, diagnosticTables, methodDescription, methodReferences, snapshotStudyset, snapshotAnnotation, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new meta-analysis result
     * @param {ResultInit} [resultInit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public metaAnalysisResultsPost(resultInit?: ResultInit, options?: RawAxiosRequestConfig) {
        return ComposeApiFp(this.configuration).metaAnalysisResultsPost(resultInit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Resolve a Neurostore annotation reference using the same ID exposed by the Neurostore API, including each linked snapshot\'s compose ID and md5.
     * @summary Get a Neurostore annotation reference by Neurostore ID
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public neurostoreAnnotationsIdGet(id: string, options?: RawAxiosRequestConfig) {
        return ComposeApiFp(this.configuration).neurostoreAnnotationsIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Your GET endpoint
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public neurostoreStudiesGet(options?: RawAxiosRequestConfig) {
        return ComposeApiFp(this.configuration).neurostoreStudiesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Your GET endpoint
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public neurostoreStudiesIdGet(id: string, options?: RawAxiosRequestConfig) {
        return ComposeApiFp(this.configuration).neurostoreStudiesIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List reference rows keyed by the actual Neurostore studyset ID, including compact snapshot summaries.
     * @summary List Neurostore studyset references
     * @param {boolean} [nested] show nested component instead of id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public neurostoreStudysetsGet(nested?: boolean, options?: RawAxiosRequestConfig) {
        return ComposeApiFp(this.configuration).neurostoreStudysetsGet(nested, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Resolve a Neurostore studyset reference using the same ID exposed by the Neurostore API, including each linked snapshot\'s compose ID and md5.
     * @summary Get a Neurostore studyset reference by Neurostore ID
     * @param {string} id 
     * @param {boolean} [nested] show nested component instead of id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public neurostoreStudysetsIdGet(id: string, nested?: boolean, options?: RawAxiosRequestConfig) {
        return ComposeApiFp(this.configuration).neurostoreStudysetsIdGet(id, nested, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get neurovault collections
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public neurovaultCollectionsGet(options?: RawAxiosRequestConfig) {
        return ComposeApiFp(this.configuration).neurovaultCollectionsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Your GET endpoint
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public neurovaultCollectionsIdGet(id: string, options?: RawAxiosRequestConfig) {
        return ComposeApiFp(this.configuration).neurovaultCollectionsIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public neurovaultCollectionsIdPut(id: string, options?: RawAxiosRequestConfig) {
        return ComposeApiFp(this.configuration).neurovaultCollectionsIdPut(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create neurovault collection
     * @param {NeurovaultCollection} [neurovaultCollection] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public neurovaultCollectionsPost(neurovaultCollection?: NeurovaultCollection, options?: RawAxiosRequestConfig) {
        return ComposeApiFp(this.configuration).neurovaultCollectionsPost(neurovaultCollection, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Your GET endpoint
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public neurovaultFilesGet(options?: RawAxiosRequestConfig) {
        return ComposeApiFp(this.configuration).neurovaultFilesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Your GET endpoint
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public neurovaultFilesIdGet(id: string, options?: RawAxiosRequestConfig) {
        return ComposeApiFp(this.configuration).neurovaultFilesIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} id 
     * @param {string | null} [collectionId] 
     * @param {string | null} [exception] 
     * @param {string | null} [traceback] 
     * @param {string} [status] 
     * @param {string | null} [imageId] 
     * @param {string | null} [name] 
     * @param {string | null} [url] 
     * @param {File} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public neurovaultFilesIdPut(id: string, collectionId?: string | null, exception?: string | null, traceback?: string | null, status?: string, imageId?: string | null, name?: string | null, url?: string | null, file?: File, options?: RawAxiosRequestConfig) {
        return ComposeApiFp(this.configuration).neurovaultFilesIdPut(id, collectionId, exception, traceback, status, imageId, name, url, file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {NeurovaultFile} [neurovaultFile] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public neurovaultFilesPost(neurovaultFile?: NeurovaultFile, options?: RawAxiosRequestConfig) {
        return ComposeApiFp(this.configuration).neurovaultFilesPost(neurovaultFile, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Your GET endpoint
     * @param {number} [page] page of results
     * @param {number} [pageSize] number of elements to return on a page
     * @param {string} [name] search the name field for a term
     * @param {string} [search] search for entries that contain the substring
     * @param {string} [description] search description field for a term
     * @param {string} [sort] Parameter to sort results on
     * @param {boolean} [desc] sort results by descending order (as opposed to ascending order)
     * @param {string} [userId] user id you want to filter on
     * @param {boolean} [includeProvenance] include the project provenance payload in project responses
     * @param {Array<string>} [tag] only return projects carrying every one of these tag names (case-insensitive)
     * @param {Array<string>} [excludeTag] drop projects carrying any of these tag names (case-insensitive); use this to hide projects a user has tagged away
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public projectsGet(page?: number, pageSize?: number, name?: string, search?: string, description?: string, sort?: string, desc?: boolean, userId?: string, includeProvenance?: boolean, tag?: Array<string>, excludeTag?: Array<string>, options?: RawAxiosRequestConfig) {
        return ComposeApiFp(this.configuration).projectsGet(page, pageSize, name, search, description, sort, desc, userId, includeProvenance, tag, excludeTag, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public projectsIdDelete(id: string, options?: RawAxiosRequestConfig) {
        return ComposeApiFp(this.configuration).projectsIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Your GET endpoint
     * @param {string} id 
     * @param {boolean} [info] display additional information about a nested relationship without displaying fully nested object
     * @param {boolean} [includeProvenance] include the project provenance payload in project responses
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public projectsIdGet(id: string, info?: boolean, includeProvenance?: boolean, options?: RawAxiosRequestConfig) {
        return ComposeApiFp(this.configuration).projectsIdGet(id, info, includeProvenance, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} id 
     * @param {boolean} [syncMetaAnalysesPublic] when updating a project\&#39;s public flag, also set each child meta-analysis to the same public value
     * @param {Project} [project] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public projectsIdPut(id: string, syncMetaAnalysesPublic?: boolean, project?: Project, options?: RawAxiosRequestConfig) {
        return ComposeApiFp(this.configuration).projectsIdPut(id, syncMetaAnalysesPublic, project, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} [sourceId] clone an existing project when creating a new project
     * @param {boolean} [copyAnnotations] when cloning via &#x60;source_id&#x60;, also duplicate associated annotations
     * @param {Project} [project] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public projectsPost(sourceId?: string, copyAnnotations?: boolean, project?: Project, options?: RawAxiosRequestConfig) {
        return ComposeApiFp(this.configuration).projectsPost(sourceId, copyAnnotations, project, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get a list of serialized/referenced annotations
     * @summary GET a list of annotations
     * @param {boolean} [nested] show nested component instead of id
     * @param {Array<string>} [ids] choose the specific ids you wish to get
     * @param {number} [page] page of results
     * @param {number} [pageSize] number of elements to return on a page
     * @param {string} [search] search for entries that contain the substring
     * @param {string} [sort] Parameter to sort results on
     * @param {boolean} [desc] sort results by descending order (as opposed to ascending order)
     * @param {string} [userId] user id you want to filter on
     * @param {boolean} [info] display additional information about a nested relationship without displaying fully nested object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public snapshotAnnotationsGet(nested?: boolean, ids?: Array<string>, page?: number, pageSize?: number, search?: string, sort?: string, desc?: boolean, userId?: string, info?: boolean, options?: RawAxiosRequestConfig) {
        return ComposeApiFp(this.configuration).snapshotAnnotationsGet(nested, ids, page, pageSize, search, sort, desc, userId, info, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get a single annotation
     * @summary GET information about an annotation
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public snapshotAnnotationsIdGet(id: string, options?: RawAxiosRequestConfig) {
        return ComposeApiFp(this.configuration).snapshotAnnotationsIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * update an existing annotation
     * @summary Update an Annotation
     * @param {string} id 
     * @param {AnnotationUpdate} [annotationUpdate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public snapshotAnnotationsIdPut(id: string, annotationUpdate?: AnnotationUpdate, options?: RawAxiosRequestConfig) {
        return ComposeApiFp(this.configuration).snapshotAnnotationsIdPut(id, annotationUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * create a new serialized/referenced annotation
     * @summary Create a new Annotation
     * @param {AnnotationPostBody} [annotationPostBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public snapshotAnnotationsPost(annotationPostBody?: AnnotationPostBody, options?: RawAxiosRequestConfig) {
        return ComposeApiFp(this.configuration).snapshotAnnotationsPost(annotationPostBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get a list of serialized/referenced studysets
     * @summary Get a list of Studysets
     * @param {boolean} [nested] show nested component instead of id
     * @param {Array<string>} [ids] choose the specific ids you wish to get
     * @param {number} [page] page of results
     * @param {number} [pageSize] number of elements to return on a page
     * @param {string} [search] search for entries that contain the substring
     * @param {string} [sort] Parameter to sort results on
     * @param {boolean} [desc] sort results by descending order (as opposed to ascending order)
     * @param {string} [userId] user id you want to filter on
     * @param {boolean} [info] display additional information about a nested relationship without displaying fully nested object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public snapshotStudysetsGet(nested?: boolean, ids?: Array<string>, page?: number, pageSize?: number, search?: string, sort?: string, desc?: boolean, userId?: string, info?: boolean, options?: RawAxiosRequestConfig) {
        return ComposeApiFp(this.configuration).snapshotStudysetsGet(nested, ids, page, pageSize, search, sort, desc, userId, info, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get a single serialized/referenced studyset
     * @summary Get information about a Studyset
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public snapshotStudysetsIdGet(id: string, options?: RawAxiosRequestConfig) {
        return ComposeApiFp(this.configuration).snapshotStudysetsIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * update an existing serialized/referenced studyset
     * @summary Update a Studyset
     * @param {string} id 
     * @param {Studyset} [studyset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public snapshotStudysetsIdPut(id: string, studyset?: Studyset, options?: RawAxiosRequestConfig) {
        return ComposeApiFp(this.configuration).snapshotStudysetsIdPut(id, studyset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * create a new serialized/referenced studyset
     * @summary Create a new Studyset
     * @param {StudysetPostBody} [studysetPostBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public snapshotStudysetsPost(studysetPostBody?: StudysetPostBody, options?: RawAxiosRequestConfig) {
        return ComposeApiFp(this.configuration).snapshotStudysetsPost(studysetPostBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * list of meta-analysis specifications
     * @summary Get a list of Specifications
     * @param {boolean} [nested] show nested component instead of id
     * @param {Array<string>} [ids] choose the specific ids you wish to get
     * @param {number} [page] page of results
     * @param {number} [pageSize] number of elements to return on a page
     * @param {string} [search] search for entries that contain the substring
     * @param {string} [sort] Parameter to sort results on
     * @param {boolean} [desc] sort results by descending order (as opposed to ascending order)
     * @param {string} [userId] user id you want to filter on
     * @param {boolean} [info] display additional information about a nested relationship without displaying fully nested object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public specificationsGet(nested?: boolean, ids?: Array<string>, page?: number, pageSize?: number, search?: string, sort?: string, desc?: boolean, userId?: string, info?: boolean, options?: RawAxiosRequestConfig) {
        return ComposeApiFp(this.configuration).specificationsGet(nested, ids, page, pageSize, search, sort, desc, userId, info, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get a meta-analysis specification
     * @summary Get information about a Specification
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public specificationsIdGet(id: string, options?: RawAxiosRequestConfig) {
        return ComposeApiFp(this.configuration).specificationsIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * update an existing meta analysis specification
     * @summary Update Meta-Analysis specification
     * @param {string} id 
     * @param {Specification} [specification] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public specificationsIdPut(id: string, specification?: Specification, options?: RawAxiosRequestConfig) {
        return ComposeApiFp(this.configuration).specificationsIdPut(id, specification, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * create a new meta-analysis specification
     * @summary Create a Specification
     * @param {SpecificationPostBody} [specificationPostBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public specificationsPost(specificationPostBody?: SpecificationPostBody, options?: RawAxiosRequestConfig) {
        return ComposeApiFp(this.configuration).specificationsPost(specificationPostBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a list of Tags
     * @param {Array<string>} [ids] choose the specific ids you wish to get
     * @param {number} [page] page of results
     * @param {number} [pageSize] number of elements to return on a page
     * @param {string} [name] search the name field for a term
     * @param {string} [search] search for entries that contain the substring
     * @param {string} [filter] alias for search when filtering tags
     * @param {string} [description] search description field for a term
     * @param {string} [group] filter tags by group
     * @param {boolean} [official] filter tags by official flag
     * @param {string} [sort] Parameter to sort results on
     * @param {boolean} [desc] sort results by descending order (as opposed to ascending order)
     * @param {string} [userId] user id you want to filter on
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public tagsGet(ids?: Array<string>, page?: number, pageSize?: number, name?: string, search?: string, filter?: string, description?: string, group?: string, official?: boolean, sort?: string, desc?: boolean, userId?: string, options?: RawAxiosRequestConfig) {
        return ComposeApiFp(this.configuration).tagsGet(ids, page, pageSize, name, search, filter, description, group, official, sort, desc, userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get information about a Tag
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public tagsIdGet(id: string, options?: RawAxiosRequestConfig) {
        return ComposeApiFp(this.configuration).tagsIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new Tag
     * @param {Tag} [tag] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public tagsPost(tag?: Tag, options?: RawAxiosRequestConfig) {
        return ComposeApiFp(this.configuration).tagsPost(tag, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all users
     * @summary GET list of Users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public usersGet(options?: RawAxiosRequestConfig) {
        return ComposeApiFp(this.configuration).usersGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve the information of the user with the matching user ID.
     * @summary Get User Info by User ID
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public usersIdGet(id: string, options?: RawAxiosRequestConfig) {
        return ComposeApiFp(this.configuration).usersIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * update information about a user
     * @summary Update User Information
     * @param {string} id 
     * @param {User} [user] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public usersIdPut(id: string, user?: User, options?: RawAxiosRequestConfig) {
        return ComposeApiFp(this.configuration).usersIdPut(id, user, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * create a single user
     * @summary Create A New User
     * @param {User} [user] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public usersPost(user?: User, options?: RawAxiosRequestConfig) {
        return ComposeApiFp(this.configuration).usersPost(user, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DefaultApi - axios parameter creator
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metaAnalysesIdDelete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('metaAnalysesIdDelete', 'id', id)
            const localVarPath = `/meta-analyses/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JSON-Web-Token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        neurostoreStudiesIdPut: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('neurostoreStudiesIdPut', 'id', id)
            const localVarPath = `/neurostore-studies/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JSON-Web-Token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        neurostoreStudiesPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/neurostore-studies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JSON-Web-Token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async metaAnalysesIdDelete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.metaAnalysesIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.metaAnalysesIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async neurostoreStudiesIdPut(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NeurostoreStudyReturn>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.neurostoreStudiesIdPut(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.neurostoreStudiesIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async neurostoreStudiesPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NeurostoreStudyReturn>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.neurostoreStudiesPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.neurostoreStudiesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DefaultApi - factory interface
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metaAnalysesIdDelete(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.metaAnalysesIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        neurostoreStudiesIdPut(id: string, options?: RawAxiosRequestConfig): AxiosPromise<NeurostoreStudyReturn> {
            return localVarFp.neurostoreStudiesIdPut(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        neurostoreStudiesPost(options?: RawAxiosRequestConfig): AxiosPromise<NeurostoreStudyReturn> {
            return localVarFp.neurostoreStudiesPost(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DefaultApi - object-oriented interface
 */
export class DefaultApi extends BaseAPI {
    /**
     * 
     * @summary 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public metaAnalysesIdDelete(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).metaAnalysesIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public neurostoreStudiesIdPut(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).neurostoreStudiesIdPut(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public neurostoreStudiesPost(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).neurostoreStudiesPost(options).then((request) => request(this.axios, this.basePath));
    }
}



